<template>
    <div v-cloak>
        <!-- Map -->
        <!-- <div v-show="mapSwitch" class="floating-bubble text-right" style="cursor: pointer;" v-html="mapIcon" @click="switchMap()"></div> -->
        <div id="summary-switch" v-show="!mapSwitch && searchStart" class="summary-toggle" v-html="listIcon" @click="switchMap()"></div>
        <b-popover v-if="searchStart" :show.sync="mapPop" custom-class="mapSwitchColor" target="summary-switch" placement="left">
            Click Here
        </b-popover>
        <div class="map-container column-map right-pos-map map-col"  v-show="!mapSwitch" :class="{menuOff: !menuStatus}">
            <img v-if="is_loading" style="width: 100%;" src="/images/spinner.gif">
            <div id="map-main"></div>
            <div class="marker-sample hidden-xs">
                <div><svg class="marker-icon" width="20" height="30" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#0b4add" stroke="white" stroke-width="3"/></svg><span class="marker-label"> In Process</span></div>
                <div><svg class="marker-icon" width="20" height="30" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#f5f242" stroke="white" stroke-width="3"/></svg><span class="marker-label"> Coming Soon</span></div>
                <div><svg class="marker-icon" width="20" height="30" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#ff1953" stroke="white" stroke-width="3"/></svg><span class="marker-label"> Complete</span></div>
            </div>
            <div class="poly-clean" title="Clean"><span><i class="fa fa-music"></i></span></div>
            <div class="scrollContorl mapnavbtn" title="Enable Scrolling"><span><i class="fa fa-lock"></i></span></div>
        </div>
        <div v-show="mapSwitch" class="map-container column-map right-pos-map summary-view" :class="{menuOff: !menuStatus}">
            <div class="p-5">
                <div class="row pb-5">
                    <div class="col-md-10 text-left">
                        <template v-if="query['status[]'] == 'selling_soon'">
                        <h1 class="list-table-header" style="color: #FF9357;">Selling Soon Projects</h1>
                        </template>
                        <template v-if="query['status[]'] == 'now_selling'">
                        <h1 class="list-table-header" style="color: #68CA72;">Now Selling Projects</h1>
                        </template>
                        <template v-if="query['status[]'] == 'in_planning'">
                        <h1 class="list-table-header" style="color: #79B8F2;">In Planning Projects</h1>
                        </template>
                        <template v-if="query['status[]'] == 'sold_out'">
                        <h1 class="list-table-header" style="color: #ff1953;">Sold Out Projects</h1>
                        </template>
                    </div>
                </div>
                <img v-if="is_loading" style="width: 100%;" src="/images/spinner.gif">
                <div class="row">
                    <table v-if="!is_loading" class="table list-table">
                        <template v-if="query['status[]'] == 'in_planning'">
                            <thead class="summary-table-header">
                                <tr class="summary-table-header-row navy-header">
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ad')" style="width: 12%;">Project</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dev')" style="width: 11%">Developer/Consultant</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ptype')" style="width: 10%">Project Type</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-story')" style="width: 5%">Storeys</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-total-u')" style="width: 6%">Total Units</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-rz-status')" style="width: 9%;padding: 1.5rem 0.5rem">
                                        <b-dropdown id="dropdown-rz" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">Rezoning Status</span>
                                            </template>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleRzStatus('Not Submitted')"><span class="status-circle mr-2 status-grey"></span>Not Submitted</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleRzStatus('In Process')"><span class="status-circle mr-2 status-yellow"></span>In Process</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleRzStatus('Approved')"><span class="status-circle mr-2 status-purple"></span>Approved</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleRzStatus('Issued')"><span class="status-circle mr-2 status-blue"></span>Issued</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleRzStatus('Complete')"><span class="status-circle mr-2 status-green"></span>Complete</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleRzStatus('Denied')"><span class="status-circle mr-2 status-red"></span>Denied</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <th scope="col" class="summary-sort" style="width: 20%">
                                        <b-dropdown id="rz-dropdown-date" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">Rezonning Dates</span>
                                            </template>
                                            <span class="custom-dropdown-text">Submission</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('rzSubNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('rzSubNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('rzSubOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('rzSubOld')"></span>Oldest</b-dropdown-item>
                                            <b-dropdown-divider class="custom-dropdown-divider"></b-dropdown-divider>
                                            <span class="custom-dropdown-text">Approval</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('rzAppNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('rzAppNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleDateSorting('rzAppOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('rzAppOld')"></span>Oldest</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dp-status')" style="width: 9%">
                                        <b-dropdown id="dp-dropdown" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">DP Status</span>
                                            </template>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Not Submitted')"><span class="status-circle mr-2 status-grey"></span>Not Submitted</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('In Process')"><span class="status-circle mr-2 status-yellow"></span>In Process</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Approved')"><span class="status-circle mr-2 status-purple"></span>Approved</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Issued')"><span class="status-circle mr-2 status-blue"></span>Issued</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Complete')"><span class="status-circle mr-2 status-green"></span>Complete</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleDpStatus('Denied')"><span class="status-circle mr-2 status-red"></span>Denied</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <th scope="col" class="summary-sort" style="width: 20%">
                                        <b-dropdown id="dp-dropdown-date" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">DP Dates</span>
                                            </template>
                                            <span class="custom-dropdown-text">Submission</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('dpSubNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpSubNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('dpSubOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpSubOld')"></span>Oldest</b-dropdown-item>
                                            <b-dropdown-divider class="custom-dropdown-divider"></b-dropdown-divider>
                                            <span class="custom-dropdown-text">Approval</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('dpAppNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpAppNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleDateSorting('dpAppOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpAppOld')"></span>Oldest</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-dp-sub-date')" style="width: 10%">DP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dp-ap-date')" style="width: 10%">DP Issued Date</th> -->
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-bp-status')">BP Status</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-sub-date')">BP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-ap-date')">BP Issued Date</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="type in typesSort" v-if="(!rzFilter || rzFilter == type.rezoning_status) && (!dpFilter || dpFilter == type.dp_status)">
                                    <td class="text-left">
                                        <a :href="type.ref_link" style="text-decoration: underline;color: #2264FF;">
                                            <!-- <div>{{type.project_name}}</div> -->
                                            <div>{{type.address}}</div>
                                        </a>
                                    </td>
                                    <td>{{type.developer}}</td>
                                    <td>{{type.project_type}}</td>
                                    <td>{{type.current_storeys ? type.current_storeys : '-'}}</td>
                                    <td>{{type.units ? type.units : '-'}}</td>
                                    <td style="padding: 1.5rem 0.5rem"><span class="status-circle mr-2" :class="statusSwitch(type.rezoning_status)"></span>{{type.rezoning_status}}</td>
                                    <td>
                                        <div v-if="type.rz_sub_date"><span style="text-transform: uppercase;">{{toggleGroupOneStatus(type.rezoning_status)}}</span><span style="margin-left: 5px;">{{type.rz_sub_date}}</span></div>
                                        <div v-if="type.rz_app_date"><span style="text-transform: uppercase;">{{toggleGroupTwoStatus(type.rezoning_status)}}</span><span  style="margin-left: 5px;">{{type.rz_app_date}}</span></div>
                                    </td>
                                    <td style="padding: 1.5rem 0.5rem"><span class="status-circle mr-2" :class="statusSwitch(type.dp_status)"></span>{{type.dp_status}}</td>
                                    <td>
                                        <div v-if="type.dp_sub_date"><span style="text-transform: uppercase;">{{toggleGroupOneStatus(type.dp_status)}}</span><span style="margin-left: 5px;">{{type.dp_sub_date}}</span></div>
                                        <div v-if="type.dp_app_date"><span style="text-transform: uppercase;">{{toggleGroupTwoStatus(type.dp_status)}}</span><span  style="margin-left: 5px;">{{type.dp_app_date}}</span></div>
                                    </td>
                                    <!-- <td>{{type.rz_sub_date}}</td>
                                    <td>{{type.rz_ap_date}}</td>
                                    <td>{{type.dp_status}}</td>
                                    <td>{{type.dp_sub_date}}</td>
                                    <td>{{type.dp_ap_date}}</td> -->
                                    <!-- <td>{{type.bp_status}}</td>
                                    <td>{{type.bp_sub_date}}</td>
                                    <td>{{type.bp_ap_date}}</td> -->
                                </tr>
                            </tbody>
                        </template>
                        <template v-if="query['status[]'] == 'now_selling'">
                            <thead class="summary-table-header">
                                <tr class="summary-table-header-row navy-header">
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ad')" style="width: 13%;">Project</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dev')" style="width: 13%">Developer/Consultant</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ptype')" style="width: 14%">Project Type</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-story')" style="width: 7%">Storeys</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-total-u')" style="width: 7%">Units</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-sold')" style="width: 7%">Sold</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-sales-start-date')" style="width: 18%;">Sales Start Date</th>
                                    <th scope="col" class="summary-sort" style="width: 11%">
                                        <b-dropdown id="dropdown-construction-status" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">Construction Status</span>
                                            </template>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleConstruction('Pre-Construction')"><span class="status-circle mr-2"></span>Pre-Construction</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleConstruction('In Process')"><span class="status-circle mr-2"></span>In Process</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleConstruction('Excavation')"><span class="status-circle mr-2"></span>Excavation</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleConstruction('Foundation')"><span class="status-circle mr-2"></span>Foundation</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleConstruction('Framing')"><span class="status-circle mr-2"></span>Framing</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleConstruction('Interior')"><span class="status-circle mr-2"></span>Interior</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleConstruction('Some Homes Complete')"><span class="status-circle mr-2"></span>Some Homes Complete</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleConstruction('Complete')"><span class="status-circle mr-2"></span>Complete</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-psf')" style="width: 10%">$PSF</th>
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-dp-sub-date')" style="width: 10%">DP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dp-ap-date')" style="width: 10%">DP Issued Date</th> -->
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-bp-status')">BP Status</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-sub-date')">BP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-ap-date')">BP Issued Date</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="type in typesSort" v-if="!constructionFilter || constructionFilter == type.construction_status">
                                    <template v-if="!constructionFilter || constructionFilter == type.construction_status">
                                        <td class="text-left">
                                            <a :href="type.ref_link" style="text-decoration: underline;color: #2264FF;">
                                                <div>{{type.project_name}}</div>
                                            </a>
                                            <div style="padding-top: 5px;">{{type.address}}</div>
                                        </td>
                                        <td>{{type.developer}}</td>
                                        <td>{{type.project_type}}</td>
                                        <td>{{type.current_storeys ? type.current_storeys : '-'}}</td>
                                        <td>{{type.units ? type.units : '-'}}</td>
                                        <td>{{type.sold_unit_percent ? type.sold_unit_percent+'%' : '-'}}</td>
                                        <!-- <td>{{type.sold ? type.sold : '-'}}</td> -->
                                        <td>
                                            <div>{{type.sales_start_date ? type.sales_start_date : '-'}}</div>
                                        </td>
                                        <td>{{type.construction_status ? type.construction_status : '-'}}</td>
                                        <td>
                                            <div v-if="type.psf > 0">${{type.psf | numFormat}}</div>
                                            <div v-else>-</div>
                                        </td>
                                        <!-- <td>{{type.rz_sub_date}}</td>
                                        <td>{{type.rz_ap_date}}</td>
                                        <td>{{type.dp_status}}</td>
                                        <td>{{type.dp_sub_date}}</td>
                                        <td>{{type.dp_ap_date}}</td> -->
                                        <!-- <td>{{type.bp_status}}</td>
                                        <td>{{type.bp_sub_date}}</td>
                                        <td>{{type.bp_ap_date}}</td> -->
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                        <template v-if="query['status[]'] == 'sold_out'">
                            <thead class="summary-table-header">
                                <tr class="summary-table-header-row navy-header">
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ad')" style="width: 13%;">Project</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dev')" style="width: 13%">Developer/Consultant</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ptype')" style="width: 14%">Project Type</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-story')" style="width: 7%">Storeys</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-total-u')" style="width: 7%">Units</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-sold')" style="width: 7%">Sold</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-sold-out-date')" style="width: 15%;">Sold Out Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-construction-complete-date')" style="width: 15%;">Construction Complete Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-psf')" style="width: 10%">$PSF</th>
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-dp-sub-date')" style="width: 10%">DP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dp-ap-date')" style="width: 10%">DP Issued Date</th> -->
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-bp-status')">BP Status</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-sub-date')">BP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-ap-date')">BP Issued Date</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="type in typesSort" v-if="!constructionFilter || constructionFilter == type.construction_status">
                                    <template v-if="!constructionFilter || constructionFilter == type.construction_status">
                                        <td class="text-left">
                                            <a :href="type.ref_link" style="text-decoration: underline;color: #2264FF;">
                                                <div>{{type.project_name}}</div>
                                            </a>
                                            <div style="padding-top: 5px;">{{type.address}}</div>
                                        </td>
                                        <td>{{type.developer}}</td>
                                        <td>{{type.project_type}}</td>
                                        <td>{{type.current_storeys ? type.current_storeys : '-'}}</td>
                                        <td>{{type.units ? type.units : '-'}}</td>
                                        <td>{{type.sold_unit_percent ? type.sold_unit_percent+'%' : '-'}}</td>
                                        <!-- <td>{{type.sold ? type.sold : '-'}}</td> -->
                                        <td>
                                            <div>{{type.sold_out_date ? type.sold_out_date : '-'}}</div>
                                        </td>
                                        <td>{{type.construction_complete_date ? type.construction_complete_date : '-'}}</td>
                                        <td>
                                            <div v-if="type.psf > 0">${{type.psf | numFormat}}</div>
                                            <div v-else>-</div>
                                        </td>
                                        <!-- <td>{{type.rz_sub_date}}</td>
                                        <td>{{type.rz_ap_date}}</td>
                                        <td>{{type.dp_status}}</td>
                                        <td>{{type.dp_sub_date}}</td>
                                        <td>{{type.dp_ap_date}}</td> -->
                                        <!-- <td>{{type.bp_status}}</td>
                                        <td>{{type.bp_sub_date}}</td>
                                        <td>{{type.bp_ap_date}}</td> -->
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                        <template v-if="query['status[]'] == 'selling_soon'">
                            <thead class="summary-table-header">
                                <tr class="summary-table-header-row navy-header">
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ad')" style="width: 12%;">Project</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dev')" style="width: 11%">Developer/Consultant</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-ptype')" style="width: 10%">Project Type</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-story')" style="width: 5%">Storeys</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-total-u')" style="width: 6%">Total Units</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dp-status')" style="width: 9%;">
                                        <b-dropdown id="dp-dropdown" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">DP Status</span>
                                            </template>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Not Submitted')"><span class="status-circle mr-2 status-grey"></span>Not Submitted</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('In Process')"><span class="status-circle mr-2 status-yellow"></span>In Process</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Approved')"><span class="status-circle mr-2 status-purple"></span>Approved</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Issued')"><span class="status-circle mr-2 status-blue"></span>Issued</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDpStatus('Complete')"><span class="status-circle mr-2 status-green"></span>Complete</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleDpStatus('Denied')"><span class="status-circle mr-2 status-red"></span>Denied</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <th scope="col" class="summary-sort" style="width: 20%">
                                        <b-dropdown id="dp-dropdown-date" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">DP Dates</span>
                                            </template>
                                            <span class="custom-dropdown-text">Submission</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('dpSubNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpSubNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('dpSubOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpSubOld')"></span>Oldest</b-dropdown-item>
                                            <b-dropdown-divider class="custom-dropdown-divider"></b-dropdown-divider>
                                            <span class="custom-dropdown-text">Approval</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('dpAppNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpAppNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleDateSorting('dpAppOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('dpAppOld')"></span>Oldest</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-status')" style="width: 9%">
                                        <b-dropdown id="bp-dropdown" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">BP Status</span>
                                            </template>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleBpStatus('Not Submitted')"><span class="status-circle mr-2 status-grey"></span>Not Submitted</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleBpStatus('In Process')"><span class="status-circle mr-2 status-yellow"></span>In Process</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleBpStatus('Approved')"><span class="status-circle mr-2 status-purple"></span>Approved</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleBpStatus('Issued')"><span class="status-circle mr-2 status-blue"></span>Issued</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleBpStatus('Complete')"><span class="status-circle mr-2 status-green"></span>Complete</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleBpStatus('Denied')"><span class="status-circle mr-2 status-red"></span>Denied</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <th scope="col" class="summary-sort" style="width: 20%">
                                        <b-dropdown id="bp-dropdown-date" block variant="link" class="custom-dropdown">
                                            <template v-slot:button-content>
                                                <span class="custom-dropdown">BP Dates</span>
                                            </template>
                                            <span class="custom-dropdown-text">Submission</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('bpSubNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('bpSubNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('bpSubOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('bpSubOld')"></span>Oldest</b-dropdown-item>
                                            <b-dropdown-divider class="custom-dropdown-divider"></b-dropdown-divider>
                                            <span class="custom-dropdown-text">Approval</span>
                                            <b-dropdown-item class="custom-dropdown-item" @click="toggleDateSorting('bpAppNew')"><span class="status-circle mr-2 status-empty" :class="dateSorting('bpAppNew')"></span>Newest</b-dropdown-item>
                                            <b-dropdown-item class="custom-dropdown-item custom-dropdown-item-last" @click="toggleDateSorting('bpAppOld')"><span class="status-circle mr-2 status-empty" :class="dateSorting('bpAppOld')"></span>Oldest</b-dropdown-item>
                                        </b-dropdown>
                                    </th>
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-dp-sub-date')" style="width: 10%">DP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-dp-ap-date')" style="width: 10%">DP Issued Date</th> -->
                                    <!-- <th scope="col" class="summary-sort" @click="project_sort('sort-bp-status')">BP Status</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-sub-date')">BP Submission Date</th>
                                    <th scope="col" class="summary-sort" @click="project_sort('sort-bp-ap-date')">BP Issued Date</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="type in typesSort" v-if="(!bpFilter || bpFilter == type.bp_status) && (!dpFilter || dpFilter == type.dp_status)">
                                    <td class="text-left">
                                        <a :href="type.ref_link" style="text-decoration: underline;color: #2264FF;">
                                            <div>{{type.project_name}}</div>
                                        </a>
                                        <div style="padding-top: 5px;">{{type.address}}</div>
                                    </td>
                                    <td>{{type.developer}}</td>
                                    <td>{{type.project_type}}</td>
                                    <td>{{type.current_storeys ? type.current_storeys : '-'}}</td>
                                    <td>{{type.units ? type.units : '-'}}</td>
                                    <td style="padding: 1.5rem 0.5rem"><span class="status-circle mr-1" :class="statusSwitch(type.dp_status)"></span>{{type.dp_status}}</td>
                                    <td>
                                        <div v-if="type.dp_sub_date"><span style="text-transform: uppercase;" v-html="toggleGroupOneStatus(type.dp_status)"></span><span style="margin-left: 5px;">{{type.dp_sub_date}}</span></div>
                                        <div v-if="type.dp_app_date"><span style="text-transform: uppercase;" v-html="toggleGroupTwoStatus(type.dp_status)"></span><span  style="margin-left: 5px;">{{type.dp_app_date}}</span></div>
                                    </td>
                                    <td style="padding: 1.5rem 0.5rem"><span class="status-circle mr-1" :class="statusSwitch(type.bp_status)"></span>{{type.bp_status}}</td>
                                    <td>
                                        <div v-if="type.bp_sub_date"><span style="text-transform: uppercase;" v-html="toggleGroupOneStatus(type.bp_sub_date)"></span><span style="margin-left: 5px;">{{type.bp_sub_date}}</span></div>
                                        <div v-if="type.bp_app_date"><span style="text-transform: uppercase;" v-html="toggleGroupTwoStatus(type.bp_sub_date)"></span><span  style="margin-left: 5px;">{{type.bp_app_date}}</span></div>
                                    </td>
                                    <!-- <td>{{type.rz_sub_date}}</td>
                                    <td>{{type.rz_ap_date}}</td>
                                    <td>{{type.dp_status}}</td>
                                    <td>{{type.dp_sub_date}}</td>
                                    <td>{{type.dp_ap_date}}</td> -->
                                    <!-- <td>{{type.bp_status}}</td>
                                    <td>{{type.bp_sub_date}}</td>
                                    <td>{{type.bp_ap_date}}</td> -->
                                </tr>
                            </tbody>
                        </template>
                    </table>
                </div>
                <!-- <div class="switch-map-table" v-cloak @click="switchMap()">Switch To Map</div> -->
            </div>
        </div>
        <!-- Map end -->          
        <!--col-list-wrap -->   
        <div class="col-list-wrap left-list left-menu" :class="{menuOff: !menuStatus}">
            <div class="listsearch-options fl-wrap" id="lisfw">
                <!-- <div class="menu-switch hidden-xs hidden-sm" @click="toggleMenu"><svg class="toggle-menu" width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="14" cy="14" r="14" fill="#1F293F"/>
                    <path d="M20.8987 13.1375L10.4042 13.1375L15.2246 8.31719L14.0001 7.10132L7.10156 13.9999L14.0001 20.8984L15.216 19.6826L10.4042 14.8622L20.8987 14.8622V13.1375Z" fill="white"/>
                    </svg>
                </div> -->
                <div class="small-container text-lg-left">
                    <div class="project-type-filter text-left"></div>
                    <b-tabs style="clear: left;">
                        <b-tab title="Projects" active>
                            <!-- listsearch-input-wrap  -->  
                            <div class="listsearch-input-text" id="autocomplete-container" style="box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15); padding: 7px;" v-if="role == 'admin'">
                                <span style="padding: 6px;
                                    display: inline-block;
                                    float: left;"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.60025 8.09733H9.15983L12.6944 11.639L11.639 12.6944L8.09733 9.15983V8.60025L7.90608 8.40191C7.09858 9.09608 6.05025 9.514 4.90983 9.514C2.36691 9.514 0.305664 7.45275 0.305664 4.90983C0.305664 2.36691 2.36691 0.305664 4.90983 0.305664C7.45275 0.305664 9.514 2.36691 9.514 4.90983C9.514 6.05025 9.09608 7.09858 8.40191 7.90608L8.60025 8.09733ZM1.72235 4.9098C1.72235 6.67355 3.1461 8.0973 4.90985 8.0973C6.6736 8.0973 8.09735 6.67355 8.09735 4.9098C8.09735 3.14605 6.6736 1.7223 4.90985 1.7223C3.1461 1.7223 1.72235 3.14605 1.72235 4.9098Z" fill="black" fill-opacity="0.54"/>
                                    </svg>
                                </span>
                                <input style="width: 90%;
                                    float: left;
                                    padding: 7px;
                                    background: #fff;
                                    border: none;
                                    margin-left: 5px;" v-on:keyup.enter="onGo" type="text" placeholder="Destination , Area , Street" id="autocomplete-input" class="qodef-archive-places-search" v-model="listSearch"/>
                            </div>

                            <autocomplete v-if="role == 'admin'"
                                :search="devSearch"
                                placeholder="Developer"
                                aria-label="Developer"
                                :get-result-value="getResultValue"
                                @submit="onGo"
                            ></autocomplete>

                            <div class="filter-label">PROJECT TYPE</div>
                            <div style="text-align: left;
                                font-style: normal;
                                font-weight: normal;
                                font-size: 13px;
                                line-height: 14px;
                                margin-top: 13px;
                                margin-bottom: 10px;
                                color: #949494;">Select all project types that apply</div>
                            <div class="project-type-filter text-left">
                                <div class="type-filter-button-sm" @click="toggleBool('aptIsActive')" :class="{selected: aptIsActive}">
                                    <div>Apartment</div>
                                    <svg class="apt-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="type-filter-button-lg" @click="toggleBool('mixedUseAptIsActive')" :class="{selected: mixedUseAptIsActive}">
                                    <div>Mixed-Use Apartment</div>
                                    <svg class="mixed-user-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="role == 'admin'" class="type-filter-button-lg" @click="toggleBool('podiumIsActive')" :class="{selected: podiumIsActive}">
                                    <div>Podium</div>
                                    <svg class="mixed-user-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="type-filter-button-sm" @click="toggleBool('townhomeIsActive')" :class="{selected: townhomeIsActive}">
                                    <div>Townhome</div>
                                    <svg class="townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="type-filter-button-lg" @click="toggleBool('stackedTownhomeIsActive')" :class="{selected: stackedTownhomeIsActive}">
                                    <div>Stacked Townhome</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="role == 'admin'" class="type-filter-button-lg" @click="toggleBool('rowhomeIsActive')" :class="{selected: rowhomeIsActive}">
                                    <div>Rowhome</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="role == 'admin'" class="type-filter-button-lg" @click="toggleBool('commercialIsActive')" :class="{selected: commercialIsActive}">
                                    <div>Commercial</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="role == 'admin'" class="type-filter-button-lg" @click="toggleBool('industrialIsActive')" :class="{selected: industrialIsActive}">
                                    <div>Industrial</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>

                            <div v-if="role == 'admin'" class="filter-label">CITY</div>

                            <div v-if="role == 'admin'" class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <!-- <select data-placeholder="Select all cities that apply" class="better-select" id="step2" multiple>
                                </select> -->
                                <treeselect v-model="citiesSelected" :multiple="true" :flat="true" :options="cityoptions"/>
                            </div>

                            <div v-if="role == 'admin'" class="filter-label" style="width: 100%;">GENERAL UNIT TYPE</div>

                            <div v-if="role == 'admin'" class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <treeselect v-model="gutSelected" :multiple="true" :flat="true" :options="gutoptions" :autoSelectDescendants="true"/>
                            </div>

                            <div class="filter-label">PROJECT STATUS *</div>

                            <div class="listsearch-input-item filter-status col-md-6" style="margin-top: 20px;">
                                <select data-placeholder="Select a Status" class="better-select" id="step3" multiple v-if="role == 'admin'"></select>
                                <select data-placeholder="Select a Status" class="better-select" id="step3" v-else></select>
                            </div>

                            <div v-if="role == 'admin'" class="filter-label" style="width: 100%;">CONSTRUCTION STATUS</div>

                            <div v-if="role == 'admin'" class="listsearch-input-item filter-status col-md-6" style="margin-top: 20px;">
                                <select data-placeholder="Select Status" class="better-select" id="step4" multiple>
                                    <option value="2899">Pre-Construction</option>
                                    <option value="2900">In Process</option>
                                    <option value="2905">Complete</option>
                                </select>
                            </div>

                            <div class="listsearch-input-wrap fl-wrap">
                                <div class="hidden-listing-filter fl-wrap">
                                    <div class="distance-input fl-wrap">
                                        <div class="map-opt">
                                            <div class="left-col pl-0">
                                                <div class="filter-label">REZONING STATUS</div>
                                                <div class="row rz-opts rzGroup p-0" style="margin-top: 15px;">
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="rzNo">
                                                        <input class="rzCheck" id="rzNo" type="checkbox" value="rz_nothing" v-model="rzStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">Not Submitted</span></label>
                                                    </div>
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="rzInProcess">
                                                        <input class="rzCheck" id="rzInProcess" type="checkbox" value="rz_in_progress" v-model="rzStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">In Process</span></label>
                                                    </div>
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="rzApproved">
                                                        <input class="rzCheck" id="rzApproved" type="checkbox" value="rz_approved" v-model="rzStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">Approved</span></label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row left-col pl-0">
                                                <div class="col-md-6">
                                                    <div class="filter-label">SUBMISSION DATE</div>
                                                    <date-picker class="mt-2" v-model="rzSubDate" type="date" range placeholder="Select date range"></date-picker>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="filter-label">APPROVAL DATE</div>
                                                    <date-picker class="mt-2" v-model="rzAppDate" type="date" range placeholder="Select date range"></date-picker>
                                                </div>
                                            </div>

                                            <div class="left-col pl-0">
                                                <div class="filter-label">DP STATUS</div>
                                                <div class="row rz-opts rzGroup p-0" style="margin-top: 15px;">
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="dpNotSubmitted">
                                                        <input class="rzCheck" id="dpNotSubmitted" type="checkbox" value="dp_submitted" v-model="dpStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">Not Submitted</span></label>
                                                    </div>
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="dpInProgress">
                                                        <input class="rzCheck" id="dpInProgress" type="checkbox" value="dp_inprocess" v-model="dpStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">In Process</span></label>
                                                    </div>
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="dpIssued">
                                                        <input class="rzCheck" id="dpIssued" type="checkbox" value="dp_issued" v-model="dpStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">Issued</span></label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row left-col pl-0">
                                                <div class="col-md-6">
                                                    <div class="filter-label">DP SUBMISSION DATE</div>
                                                    <date-picker class="mt-2" v-model="dpSubDate" type="date" range placeholder="Select date range"></date-picker>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="filter-label">DP APPROVAL DATE</div>
                                                    <date-picker class="mt-2" v-model="dpIssueDate" type="date" range placeholder="Select date range"></date-picker>
                                                </div>
                                            </div>

                                            <div class="left-col pl-0">
                                                <div class="filter-label">BP STATUS</div>
                                                <div class="row rz-opts rzGroup p-0" style="margin-top: 15px;">
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="bpNotSubmitted">
                                                        <input class="bpCheck" id="bpNotSubmitted" type="checkbox" value="bp_nothing" v-model="bpStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">Not Submitted</span></label>
                                                    </div>
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="bpInProgress">
                                                        <input class="bpCheck" id="bpInProgress" type="checkbox" value="bp_inprogress" v-model="bpStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">In Process</span></label>
                                                    </div>
                                                    <div class="form-check col-md-4">
                                                        <label class="form-check-label" for="bpIssued">
                                                        <input class="bpCheck" id="bpIssued" type="checkbox" value="bp_issued" v-model="bpStatus">
                                                        <span class="checkmark"></span>
                                                        <span class="filter-status-label">Issued</span></label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="row left-col pl-0">
                                                <div class="col-md-6">
                                                    <div class="filter-label">BP SUBMISSION DATE</div>
                                                    <date-picker class="mt-2" v-model="bpSubDate" type="date" range placeholder="Select date range"></date-picker>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="filter-label">BP APPROVAL DATE</div>
                                                    <date-picker class="mt-2" v-model="bpIssueDate" type="date" range placeholder="Select date range"></date-picker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- hidden-listing-filter end -->
                                <!-- <hr style="width: 50%;border: 1px solid #CCD5EA;"> -->
                                <div v-if="role == 'admin'" class="more-filter-option" @click="moreFilter">More Filters <span style="margin-top: -2px;"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 0.25C3.05 0.25 0.25 3.05 0.25 6.5C0.25 9.95 3.05 12.75 6.5 12.75C9.95 12.75 12.75 9.95 12.75 6.5C12.75 3.05 9.95 0.25 6.5 0.25ZM7.125 3.375H5.875V5.875H3.375V7.125H5.875V9.625H7.125V7.125H9.625V5.875H7.125V3.375ZM1.5 6.5C1.5 9.25625 3.74375 11.5 6.5 11.5C9.25625 11.5 11.5 9.25625 11.5 6.5C11.5 3.74375 9.25625 1.5 6.5 1.5C3.74375 1.5 1.5 3.74375 1.5 6.5Z" fill="#1F293F"/>
                                    </svg>
                                    </span>
                                </div>
                            </div>
                            <!-- <div class="filter-submit">
                                <div class="filter-reset" @click="reset">RESET</div>
                                <div class="filter-update" @click="onGo">SEARCH</div>
                            </div> -->
                            
                            <div class="filter-label" style="width: 100%;" v-if="role == 'admin'">REPORT FIELDS</div>

                            <treeselect v-if="role == 'admin'" v-model="reportSelected" :multiple="false" :flat="true" :options="reportoptions" :autoSelectDescendants="true" />

                            <div class="report-submit">
                                <div class="filter-update" @click="onReport">GENERATE</div>
                            </div>
                            <!-- listsearch-input-wrap end -->
                        </b-tab>
                        <b-tab title="Units" v-if="role == 'admin'">
                            <div class="filter-label">PROJECT TYPE</div>
                            <div style="text-align: left;
                                font-style: normal;
                                font-weight: normal;
                                font-size: 13px;
                                line-height: 14px;
                                margin-top: 13px;
                                margin-bottom: 10px;
                                color: #949494;">Select all project types that apply</div>
                            <div class="project-type-filter text-left">
                                <div class="type-filter-button-sm" @click="toggleBool('aptMLSIsActive')" :class="{selected: aptMLSIsActive}">
                                    <div>Apartment</div>
                                    <svg class="apt-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="type-filter-button-lg" @click="toggleBool('mixedUseAptMLSIsActive')" :class="{selected: mixedUseAptMLSIsActive}">
                                    <div>Mixed-Use Apartment</div>
                                    <svg class="mixed-user-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="type-filter-button-lg" @click="toggleBool('podiumMLSIsActive')" :class="{selected: podiumMLSIsActive}">
                                    <div>Podium</div>
                                    <svg class="mixed-user-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="type-filter-button-sm" @click="toggleBool('townhomeMLSIsActive')" :class="{selected: townhomeMLSIsActive}">
                                    <div>Townhome</div>
                                    <svg class="townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div class="type-filter-button-lg" @click="toggleBool('stackedTownhomeMLSIsActive')" :class="{selected: stackedTownhomeMLSIsActive}">
                                    <div>Stacked Townhome</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="role == 'admin'" class="type-filter-button-lg" @click="toggleBool('rowhomeMLSIsActive')" :class="{selected: rowhomeMLSIsActive}">
                                    <div>Rowhome</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="role == 'admin'" class="type-filter-button-lg" @click="toggleBool('commercialMLSIsActive')" :class="{selected: commercialMLSIsActive}">
                                    <div>Commercial</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                                <div v-if="role == 'admin'" class="type-filter-button-lg" @click="toggleBool('industrialMLSIsActive')" :class="{selected: industrialMLSIsActive}">
                                    <div>Industrial</div>
                                    <svg class="stacked-townhome-check filter-button-check" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="5" cy="5" r="5" fill="#4D7CE1"/>
                                        <path d="M2.77772 4.99991L4.24997 6.66361L7.22221 3.33323" stroke="white" stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </div>
                            </div>

                            <div class="filter-label">CITY</div>

                            <div class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <!-- <select data-placeholder="Select all cities that apply" class="better-select" id="step2" multiple>
                                </select> -->
                                <treeselect v-model="mlsCitiesSelected" :multiple="true" :flat="true" :options="cityoptions"/>
                            </div>

                            <div class="filter-label" style="width: 100%;">GENERAL UNIT TYPE</div>

                            <div class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <treeselect v-model="gutMLSSelected" :multiple="true" :flat="true" :options="gutoptions" :autoSelectDescendants="true"/>
                            </div>

                            <div class="filter-label">BEDS</div>
                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsBedsMin" type="text" placeholder="Min Value">
                                </div>
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsBedsMax" type="text" placeholder="Max Value">
                                </div>
                            </div>

                            <div class="filter-label">BATHS</div>
                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsBathsMin" type="text" placeholder="Min Value">
                                </div>
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsBathsMax" type="text" placeholder="Max Value">
                                </div>
                            </div>

                            <div class="filter-label">UNIT SIZE</div>
                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsUnitMin" type="text" placeholder="Min Value">
                                </div>
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsUnitMax" type="text" placeholder="Max Value">
                                </div>
                            </div>

                            <div class="filter-label" style="width: 100%;">MLS STATUS</div>

                            <div class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <treeselect v-model="statusMLSSelected" :multiple="true" :flat="true" :options="MLSStatusOptions" :autoSelectDescendants="true"/>
                            </div>

                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <div class="filter-label">LIST DATE</div>
                                    <date-picker class="mt-2" v-model="listMLSDate" type="date" range placeholder="Select date range"></date-picker>
                                </div>
                                <div class="col-md-6">
                                    <div class="filter-label">SOLD DATE</div>
                                    <date-picker class="mt-2" v-model="soldMLSDate" type="date" range placeholder="Select date range"></date-picker>
                                </div>
                            </div>

                            <div class="filter-label">LIST PRICE</div>
                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsListPriceMin" type="text" placeholder="Min Value">
                                </div>
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsListPriceMax" type="text" placeholder="Max Value">
                                </div>
                            </div>

                            <div class="filter-label">SOLD PRICE</div>
                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsSoldPriceMin" type="text" placeholder="Min Value">
                                </div>
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="mlsSoldPriceMax" type="text" placeholder="Max Value">
                                </div>
                            </div>

                            <div class="filter-submit">
                                <div class="filter-reset" @click="MLSReset">RESET</div>
                                <div class="filter-update" @click="MLSGo">SEARCH</div>
                            </div>
                        </b-tab>
                        <b-tab title="Land" v-if="role == 'admin'">
                            <div class="filter-label">LTSA PLAN</div>
                            <div class="listsearch-input-text" style="box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15); padding: 7px;">
                                <span style="padding: 6px;
                                    display: inline-block;
                                    float: left;"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.60025 8.09733H9.15983L12.6944 11.639L11.639 12.6944L8.09733 9.15983V8.60025L7.90608 8.40191C7.09858 9.09608 6.05025 9.514 4.90983 9.514C2.36691 9.514 0.305664 7.45275 0.305664 4.90983C0.305664 2.36691 2.36691 0.305664 4.90983 0.305664C7.45275 0.305664 9.514 2.36691 9.514 4.90983C9.514 6.05025 9.09608 7.09858 8.40191 7.90608L8.60025 8.09733ZM1.72235 4.9098C1.72235 6.67355 3.1461 8.0973 4.90985 8.0973C6.6736 8.0973 8.09735 6.67355 8.09735 4.9098C8.09735 3.14605 6.6736 1.7223 4.90985 1.7223C3.1461 1.7223 1.72235 3.14605 1.72235 4.9098Z" fill="black" fill-opacity="0.54"/>
                                    </svg>
                                </span>
                                <input style="width: 90%;
                                    float: left;
                                    padding: 7px;
                                    background: #fff;
                                    border: none;
                                    margin-left: 5px;" type="text" placeholder="LTSA Plan" class="qodef-archive-places-search" v-model="LTSAPlanSearch"/>
                            </div>

                            <div class="filter-label">LTSA REGISTRATION</div>
                            <div class="listsearch-input-text" style="box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.15); padding: 7px;">
                                <span style="padding: 6px;
                                    display: inline-block;
                                    float: left;"><svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.60025 8.09733H9.15983L12.6944 11.639L11.639 12.6944L8.09733 9.15983V8.60025L7.90608 8.40191C7.09858 9.09608 6.05025 9.514 4.90983 9.514C2.36691 9.514 0.305664 7.45275 0.305664 4.90983C0.305664 2.36691 2.36691 0.305664 4.90983 0.305664C7.45275 0.305664 9.514 2.36691 9.514 4.90983C9.514 6.05025 9.09608 7.09858 8.40191 7.90608L8.60025 8.09733ZM1.72235 4.9098C1.72235 6.67355 3.1461 8.0973 4.90985 8.0973C6.6736 8.0973 8.09735 6.67355 8.09735 4.9098C8.09735 3.14605 6.6736 1.7223 4.90985 1.7223C3.1461 1.7223 1.72235 3.14605 1.72235 4.9098Z" fill="black" fill-opacity="0.54"/>
                                    </svg>
                                </span>
                                <input style="width: 90%;
                                    float: left;
                                    padding: 7px;
                                    background: #fff;
                                    border: none;
                                    margin-left: 5px;" type="text" placeholder="LTSA Registration" class="qodef-archive-places-search" v-model="LTSARegistrationSearch"/>
                            </div>

                            <div class="filter-label" style="width: 100%;">LTSA PARCEL STATUS</div>
                            <div class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <treeselect v-model="parcelStatusLandSelected" :multiple="true" :flat="true" :options="parcelStatusLandOptions" :autoSelectDescendants="true"/>
                            </div>

                            <div class="filter-label">CITY</div>

                            <div class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <!-- <select data-placeholder="Select all cities that apply" class="better-select" id="step2" multiple>
                                </select> -->
                                <treeselect v-model="landCitiesSelected" :multiple="true" :flat="true" :options="cityoptions"/>
                            </div>

                            <div class="filter-label">LTSA PID</div>
                            <div class="row">
                                <div class="col-md-12">
                                    <input class="mt-2 mx-input" v-model="ltsapid" type="text" placeholder="LTSA PID">
                                </div>
                            </div>

                            <div class="filter-label" style="width: 100%;">REGISTRATION TYPE</div>
                            <div class="listsearch-input-item filter-status" style="width: 100%; margin-top: 20px;">
                                <treeselect v-model="regTypeSelected" :multiple="true" :flat="true" :options="regTypeOptions" :autoSelectDescendants="true"/>
                            </div>
                            
                            <div class="row left-col pl-0">
                                <div class="col-md-12">
                                    <div class="filter-label" style="width: 100%;">REGISTRATION DATE</div>
                                    <date-picker style="clear: left;" class="mt-2" v-model="registrationLandDate" type="date" range placeholder="Select date range"></date-picker>
                                </div>
                            </div>

                            <div class="filter-label">LAND SALE PRICE</div>
                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="landSalePriceMin" type="text" placeholder="Min Value">
                                </div>
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="landSalePriceMax" type="text" placeholder="Max Value">
                                </div>
                            </div>

                            <div class="filter-label">LTSA LOT SIZE (sqft)</div>
                            <div class="row left-col pl-0">
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="landLotSizeMin" type="text" placeholder="Min Value">
                                </div>
                                <div class="col-md-6">
                                    <input class="mt-2 mx-input" v-model="landLotSizeMax" type="text" placeholder="Max Value">
                                </div>
                            </div>

                            <div class="filter-submit">
                                <div class="filter-reset" @click="LandReset">RESET</div>
                                <div class="filter-update" @click="LandGo">SEARCH</div>
                            </div>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
            <!-- list-main-wrap-->
        </div>
        <!--col-list-wrap -->  
        <div class="limit-box fl-wrap"></div>
        <!--section -->  
        <!-- <section class="gradient-bg">
            <div class="cirle-bg">
                <div class="bg" data-bg="/images/bg/circle.png"></div>
            </div>
            <div class="container">
                <div class="join-wrap fl-wrap">
                    <div class="row">
                        <div class="col-md-8">
                            <h3>Join our online community</h3>
                            <p>Grow your marketing and be happy with your online business</p>
                        </div>
                        <div class="col-md-4"><a href="#" class="join-wrap-btn modal-open">Sign Up <i class="fa fa-sign-in"></i></a></div>
                    </div>
                </div>
            </div>
        </section> -->
        <!--section end -->
    </div>
</template>
<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import {BACKEND_URL} from '../variables.js';
    import {BTabs, BTab, BPopover, BPopoverDirective} from 'bootstrap-vue';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Autocomplete from '@trevoreyre/autocomplete-vue'
    import '@trevoreyre/autocomplete-vue/dist/style.css'

    // import BTab from 'bootstrap-vue';
    export default {
        components: { 
            DatePicker,
            'b-tabs': BTabs,
            'b-tab': BTab,
            'b-popover': BPopover,
            Treeselect,
            Autocomplete
        },
        directives: {
            'b-popover': BPopoverDirective,
        },
        data() {
            return {
                query: this.$route.query,
                projects: [],
                locations: [],
                all_types: [
                    {name: 'Apartments', value: 'apt'},
                    {name: 'Townhome', value: '2870'}
                ],
                all_type: null,
                all_city: null,
                all_status: null,
                new_type: null,
                new_city: null,
                new_status: null,
                listSearch: '',
                initBeforeSearch: true,
                mapSwitch: false,
                types: [],
                sortColumn: 'address',
                sortBy: 'sort-ad',
                orderAsc: true,
                is_loading: true,
                rzStatus: [],
                bpStatus: [],
                dpStatus: [],
                rzSubDate: [],
                rzAppDate: [],
                dpSubDate: [],
                dpIssueDate: [],
                bpSubDate: [],
                bpIssueDate: [],
                mapIcon: '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="28" cy="26" r="25" fill="#FDFDFF"/></g><path d="M18 19V32.4796L24.7146 34.2901L31.4796 32.4796L38.1942 34.2901V21.0002L31.527 19.3823L24.8598 20.8579L18 19Z" stroke="black" stroke-width="1.25" stroke-miterlimit="10"/><path d="M24.8604 20.8579V34.2901" stroke="black" stroke-width="1.25" stroke-miterlimit="10"/><path d="M31.5269 19.3823V32.4796" stroke="black" stroke-width="1.25" stroke-miterlimit="10"/><defs><filter id="filter0_d" x="0" y="0" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="4"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>',
                listIcon: '<svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><g filter="url(#filter0_d)"><circle cx="28" cy="26" r="20" fill="#FDFDFF"/></g><path d="M37.1797 25.4395H22.917C22.4639 25.4395 22.0967 25.8067 22.0967 26.2598C22.0967 26.7128 22.4639 27.0801 22.917 27.0801H37.1797C37.6328 27.0801 38 26.7128 38 26.2598C38 25.8067 37.6328 25.4395 37.1797 25.4395Z" fill="black"/><path d="M37.1797 19.2871H22.917C22.4639 19.2871 22.0967 19.6544 22.0967 20.1074C22.0967 20.5605 22.4639 20.9277 22.917 20.9277H37.1797C37.6328 20.9277 38 20.5605 38 20.1074C38 19.6544 37.6328 19.2871 37.1797 19.2871Z" fill="black"/><path d="M37.1797 31.5918H22.917C22.4639 31.5918 22.0967 31.9591 22.0967 32.4121C22.0967 32.8652 22.4639 33.2324 22.917 33.2324H37.1797C37.6328 33.2324 38 32.8652 38 32.4121C38 31.9591 37.6328 31.5918 37.1797 31.5918Z" fill="black"/><path d="M18.1074 21.2148C18.719 21.2148 19.2148 20.719 19.2148 20.1074C19.2148 19.4958 18.719 19 18.1074 19C17.4958 19 17 19.4958 17 20.1074C17 20.719 17.4958 21.2148 18.1074 21.2148Z" fill="black"/><path d="M18.1074 27.3672C18.719 27.3672 19.2148 26.8714 19.2148 26.2598C19.2148 25.6482 18.719 25.1523 18.1074 25.1523C17.4958 25.1523 17 25.6482 17 26.2598C17 26.8714 17.4958 27.3672 18.1074 27.3672Z" fill="black"/><path d="M18.1074 33.5195C18.719 33.5195 19.2148 33.0237 19.2148 32.4121C19.2148 31.8005 18.719 31.3047 18.1074 31.3047C17.4958 31.3047 17 31.8005 17 32.4121C17 33.0237 17.4958 33.5195 18.1074 33.5195Z" fill="black"/><defs><filter id="filter0_d" x="0" y="0" width="56" height="56" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="2"/><feGaussianBlur stdDeviation="4"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/></filter></defs></svg>',
                aptIsActive: false,
                townhomeIsActive: false,
                mixedUseAptIsActive: false,
                podiumIsActive: false,
                stackedTownhomeIsActive: false,
                commercialIsActive: false,
                industrialIsActive: false,
                rowhomeIsActive: false,
                aptMLSIsActive: false,
                townhomeMLSIsActive: false,
                mixedUseAptMLSIsActive: false,
                podiumMLSIsActive: false,
                stackedTownhomeMLSIsActive: false,
                commercialMLSIsActive: false,
                industrialMLSIsActive: false,
                rowhomeMLSIsActive: false,
                mapActive: true,
                menuStatus: true,
                mapBox: [],
                dateSort: 'app',
                dateNameSort: '',
                constructionFilter: '',
                rzFilter: '',
                dpFilter: '',
                bpFilter: '',
                dpDateSort: false,
                bpDateSort: false,
                rzDateSort: false,
                mapPop: false,
                searchStart: false,
                citiesSelected: [],
                mlsCitiesSelected: [],
                landCitiesSelected: [],
                gutSelected: [],
                gutMLSSelected: [],
                cityoptions: [],
                gutoptions: [],
                mlsBedsMax: null,
                mlsBedsMin: null,
                mlsUnitMax: null,
                mlsBathsMin: null,
                mlsBathsMax: null,
                mlsUnitMin: null,
                listMLSDate: [],
                soldMLSDate: [],
                mlsListPriceMin: null,
                mlsListPriceMax: null,
                mlsSoldPriceMin: null,
                mlsSoldPriceMax: null,
                developerSearch: null,
                MLSStatusOptions: [
                    {id: 8197, label: 'Active'},
                    {id: 8198, label: 'Sold'},
                    {id: 8205, label: 'Terminated'},
                    {id: 8203, label: 'Withdrawn'},
                ],
                parcelStatusLandOptions: [
                    {id: 11195, label: 'Active'},
                    {id: 11196, label: 'Cancelled'},
                    {id: 11197, label: 'Inactive'}
                ],
                regTypeOptions: [
                    {id: 11249, label: 'Title Cancel'},
                    {id: 11191, label: 'Title Transfer'},
                    {id: 11190, label: 'Mortgage'}
                ],
                LTSAPlanSearch: null,
                LTSARegistrationSearch: null,
                parcelStatusLandSelected: [],
                statusMLSSelected: [],
                regTypeSelected: [],
                ltsapid: null,
                registrationLandDate: [],
                landSalePriceMin: null,
                landSalePriceMax: null,
                landLotSizeMin: null,
                landLotSizeMax: null,
                reportSelected: '',
                reportoptions: [
                    {id:'projectTotal', label: 'Project Report', children: [
                        {id: 'sales_start_date', label: 'Sales Start Date', isDisabled: true},
                        {id: 'total_units', label: 'Total Units', isDisabled: true},
                        {id: 'rlsd_units', label: 'Rlsds Units', isDisabled: true},
                        {id: 'sold_units', label: 'Sold Units', isDisabled: true},
                        {id: 'available', label: 'Available Units', isDisabled: true},
                        {id: 'total_avg_psf', label: 'Total Average $PSF', isDisabled: true},
                        {id: 'total_avg_size', label: 'Total Avg Size', isDisabled: true},
                        {id: 'total_avg_price', label: 'Total Avg Price', isDisabled: true}
                    ]},
                    {id:'projectAvailability', label: 'Current Availability', children: [
                        {id: 'sales_start_date', label: 'Sales Start Date', isDisabled: true},
                        {id: 'total_units', label: 'Total Units', isDisabled: true},
                        {id: 'rlsd_units', label: 'Rlsds Units', isDisabled: true},
                        {id: 'sold_units', label: 'Sold Units', isDisabled: true},
                        {id: 'available', label: 'Available Units', isDisabled: true},
                        {id: 'current_avg_size', label: 'Current Avg Size', isDisabled: true},
                        {id: 'current_avg_price', label: 'Current Avg Price', isDisabled: true},
                        {id: 'current_avg_psf', label: 'Current Average $PSF', isDisabled: true}
                    ]},
                    {id:'planningReport', label: 'Planning Report ', children: [
                        {id: 'rezoning_status', label: 'Rezoning Status', isDisabled: true},
                        {id: 'dp_status', label: 'DP status', isDisabled: true},
                        {id: 'bp_status', label: 'BP Status', isDisabled: true},
                        // {id: 'application_stage', label: 'Application Stage', isDisabled: true},
                        // {id: 'application_date', label: 'Application Date ', isDisabled: true}
                    ]}
                ],
                polyGon: false,
                role: ''
            }
        },
        mounted: function() {
            // if (!this.$cookies.get("mapswitched")) {
            //     this.mapPop = true;
            // }
            const vm = this;
            let param = '';
            if ($.isArray(vm.query['type[]'])) {
                vm.query['type[]'].forEach((a) => {
                    switch (a) {
                        case '2886':
                            vm.aptIsActive = true;
                            break;
                        case '2870':
                            vm.townhomeIsActive = true;
                            break;
                        case '2884':
                            vm.mixedUseAptIsActive = true;
                            break;
                        case '3479':
                            vm.stackedTownhomeIsActive = true;
                            break;
                        case '2962':
                            vm.commercialIsActive = true;
                            break;
                        case '3047':
                            vm.industrialIsActive = true;
                            break;
                        case '6240':
                            vm.rowhomeIsActive = true;
                            break;
                        case '5910':
                            vm.podiumIsActive = true;
                            break;
                    }
                    param += 'type[]=' + a + '&';
                });
            }
            else if (typeof vm.query['type[]'] == 'undefined') {
            }
            else {
                switch (vm.query['type[]']) {
                    case '2886':
                        vm.aptIsActive = true;
                        break;
                    case '2870':
                        vm.townhomeIsActive = true;
                        break;
                    case '2884':
                        vm.mixedUseAptIsActive = true;
                        break;
                    case '3479':
                        vm.stackedTownhomeIsActive = true;
                        break;
                    case '2962':
                        vm.commercialIsActive = true;
                        break;
                    case '3047':
                        vm.industrialIsActive = true;
                        break;
                    case '6240':
                        vm.rowhomeIsActive = true;
                        break;
                    case '5910':
                        vm.podiumIsActive = true;
                        break;
                }
                param += 'type[]=' + vm.query['type[]'] + '&';
            }
            if ($.isArray(vm.query['city[]'])) {
                vm.query['city[]'].forEach((a) => {
                    param += 'city[]=' + a + '&';
                });
            }
            else if (typeof vm.query['city[]'] == 'undefined') {
            }
            else {
                param += 'city[]=' + vm.query['city[]'] + '&';
            }
            if ($.isArray(vm.query['constructionstatus[]'])) {
                vm.query['constructionstatus[]'].forEach((a) => {
                    param += 'constructionstatus[]=' + a + '&';
                });
            }
            else if (typeof vm.query['constructionstatus[]'] == 'undefined') {
            }
            else {
                param += 'constructionstatus[]=' + vm.query['constructionstatus[]'] + '&';
            }
            if ($.isArray(vm.query['unittype[]'])) {
                vm.query['unittype[]'].forEach((a) => {
                    param += 'unittype[]=' + a + '&';
                });
            }
            else if (typeof vm.query['unittype[]'] == 'undefined') {
            }
            else {
                param += 'unittype[]=' + vm.query['unittype[]'] + '&';
            }
            let dateList = [
                'rzSubDate',
                'rzAppDate',
                'dpSubDate',
                'dpIssueDate',
                'bpIssueDate',
                'bpIssueDate',
                'rzStatus',
                'bpStatus',
                'dpStatus'
            ];
            dateList.forEach((d) => {
                if ($.isArray(vm.query[d+'[]'])) {
                    vm.query[d+'[]'].forEach((a) => {
                        param += d+'[]=' + a + '&';
                    });
                }
                else if (typeof vm.query[d+'[]'] == 'undefined') {

                }
                else {
                    param += d+'[]=' + vm.query[d+'[]'] + '&';
                }
            });
            if ($.isArray(vm.query['status[]'])) {
                vm.query['status[]'].forEach((a) => {
                    param += 'status[]=' + a + '&';
                    this.all_status = a;
                });
            }
            else if (typeof vm.query['status[]'] == 'undefined') {
            }
            else {
                param += 'status[]=' + vm.query['status[]'];
                this.all_status = vm.query['status[]'];
            }

            if (vm.query['search']) {
                param += 'search=' + vm.query['search'];
                this.listSearch = vm.query['search'];
            }

            if (vm.query['developer']) {
                param += 'developer=' + vm.query['developer'];
                this.developerSearch = vm.query['developer'];
            }

            if ($.isArray(vm.query['bpStatus[]'])) {
                vm.query['bpStatus[]'].forEach((a) => {
                    this.bpStatus.push(a);
                });
            }
            else if (typeof vm.query['bpStatus[]'] == 'undefined') {
            }
            else {
                this.bpStatus.push(vm.query['bpStatus[]']);
            }

            if ($.isArray(vm.query['rzStatus[]'])) {
                vm.query['rzStatus[]'].forEach((a) => {
                    this.rzStatus.push(a);
                });
            }
            else if (typeof vm.query['rzStatus[]'] == 'undefined') {
            }
            else {
                this.rzStatus.push(vm.query['rzStatus[]']);
            }

            if ($.isArray(vm.query['rzStatus[]'])) {
                vm.query['rzStatus[]'].forEach((a) => {
                    this.rzStatus.push(a);
                });
            }
            else if (typeof vm.query['rzStatus[]'] == 'undefined') {
            }
            else {
                this.rzStatus.push(vm.query['rzStatus[]']);
            }

            if ($.isArray(vm.query['dpStatus[]'])) {
                vm.query['dpStatus[]'].forEach((a) => {
                    this.dpStatus.push(a);
                });
            }
            else if (typeof vm.query['dpStatus[]'] == 'undefined') {
            }
            else {
                this.dpStatus.push(vm.query['dpStatus[]']);
            }

            // =========== options ============
            this.all_types.forEach((a) => {
                if (a.value == this.type) {
                    $('#step1').append('<option selected value="'+ a.value + '">' + a.name + '</option>');
                    this.new_type = a.value;
                }
                else {
                        $('#step1').append('<option value="'+ a.value + '">' + a.name + '</option>');
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_role',
            }, (data, status) => {
                if (status === 'success') {
                    this.role = data.role;
                }
                if (this.role == 'admin') {
                    if (param == '') {
                        this.initBeforeSearch = true;
                        this.mapSwitch = false;
                        this.is_loading = true;
                        $.get({
                            url: BACKEND_URL + 'api/get_projects_metro_utc',
                        }, (data, status) => {
                            vm.searchStart = false;
                            vm.is_loading = false;
                            var blueMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#6EBBF8" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(blueMarker),
                            }
                            var greenMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#60B85F" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_green = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(greenMarker),
                            }
                            var yellowMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#f5f242" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_yellow = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(yellowMarker),
                            }
                            var redMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#ff1953" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_red = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(redMarker),
                            }
                            var orangeMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#FF9357" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_orange = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(orangeMarker),
                            }
                            if (status === 'success') {
                                // this.locations =
                                _.each(data, (project) => {
                                    vm.locations.push([
                                        vm.locationData(project),
                                        project
                                    ]);
                                });
                                this.mainMap();
                            }
                        });
                    }
                    else {
                        this.mapPop = true;
                        this.searchStart = true;
                        this.initBeforeSearch = false;
                        this.is_loading = true;
                        $.get({
                            url: BACKEND_URL + 'api/get_projects_utc?' + param,
                        }, (data, status) => {
                            vm.searchStart = false;
                            vm.is_loading = false;
                            var blueMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#6EBBF8" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(blueMarker),
                            }
                            var greenMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#60B85F" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_green = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(greenMarker),
                            }
                            var yellowMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#f5f242" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_yellow = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(yellowMarker),
                            }
                            var redMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#ff1953" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_red = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(redMarker),
                            }
                            var orangeMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#FF9357" stroke="white" stroke-width="3"/></svg>';
                            var markerIcon_orange = {
                                anchor: new google.maps.Point(22, 16),
                                url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(orangeMarker),
                            }
                            if (status === 'success') {
                                // this.locations =
                                _.each(data, (project) => {
                                    vm.locations.push([
                                        vm.locationData(project),
                                        project
                                    ]);
                                });
                                this.mainMap();
                            }
                        });
                    }
                }
                else {
                    vm.searchStart = false;
                    vm.is_loading = false;
                    this.mainMap();
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_region',
            }, (data, status) => {
                if (status === 'success') {
                    this.cityoptions = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_gut',
            }, (data, status) => {
                if (status === 'success') {
                    this.gutoptions = data;
                }
            });
            $.get({
                url: BACKEND_URL + 'api/get_status',
            }, (data, status) => {
                if (status === 'success') {
                    data.forEach((a) => {
                        if (a.tid.replace(' ', '') == this.status) {
                            $('#step3').append('<option selected value="'+ a.tid.replace(' ', '') + '">' + a.name + '</option>');
                            this.new_status = a.tid.replace(' ', '');
                        }
                        else {
                            $('#step3').append('<option value="'+ a.tid.replace(' ', '') + '">' + a.name + '</option>');
                        }
                    })
                    // let THIS = this;
                    // $('.chosen-select').niceSelect();
                    setTimeout(function(){
                        $('.better-select').niceSelect();
                        if ($.isArray(vm.query['type[]'])) {
                            vm.query['type[]'].forEach((a) => {
                                $('#step1').next().find('ul li[data-value='+a+']').click();
                            });
                        }
                        else {
                            $('#step1').next().find('ul li[data-value='+vm.query['type[]']+']').click();
                        }
                        if ($.isArray(vm.query['city[]'])) {
                            vm.citiesSelected = vm.query['city[]'];
                        }
                        else if (vm.query['city[]']) {
                            vm.citiesSelected = [vm.query['city[]']];
                        }
                        if ($.isArray(vm.query['constructionstatus[]'])) {
                            vm.query['constructionstatus[]'].forEach((a) => {
                                $('#step4').next().find('ul li[data-value='+a+']').click();
                            });
                        }
                        else {
                            $('#step4').next().find('ul li[data-value='+vm.query['constructionstatus[]']+']').click();
                        }
                        if ($.isArray(vm.query['unittype[]'])) {
                            vm.gutSelected = vm.query['unittype[]'];
                        }
                        else if  (vm.query['unittype[]']) {
                            vm.gutSelected = [vm.query['unittype[]']];
                        }
                        if ($.isArray(vm.query['status[]'])) {
                            vm.query['status[]'].forEach((a) => {
                                $('#step3').next().find('ul li[data-value='+a+']').click();
                            });
                        }
                        else if (vm.query['status[]']) {
                            $('#step3').next().find('ul li[data-value='+vm.query['status[]']+']').click();
                        }
                        $('#step3').click();
                    //     $('#step1').on('change', () => {
                    //         THIS.onSelectType($('#step1').val())
                    //     })
                    //     $('#step2').on('change', () => {
                    //         THIS.onSelectCity($('#step2').val())
                    //     })
                    //     $('#step3').on('change', () => {
                    //         THIS.onSelectStatus($('#step3').val())
                    //     })
                    }, 500)
                }
            });
        },
        computed: {
            typesSort: function () {
                let alphSorting = {
                    'sort-ad' : 'address',
                    'sort-dev' : 'developer',
                    'sort-ptype' : 'project_type',
                    'sort-name' : 'project_name',
                    'sort-construction-status' : 'construction_status',
                }
                var vm = this;
                var ob = this.types;
                Object.keys(alphSorting).forEach(function (k) {
                    if (k == vm.sortBy) {
                        if (vm.orderAsc) {
                            ob = vm.types.sort((a,b) => (a[alphSorting[k]] > b[alphSorting[k]]) ? 1 : ((b[alphSorting[k]] > a[alphSorting[k]]) ? -1 : 0));
                        }
                        else {
                            ob = vm.types.sort((a,b) => (a[alphSorting[k]] < b[alphSorting[k]]) ? 1 : ((b[alphSorting[k]] < a[alphSorting[k]]) ? -1 : 0));
                        }
                    }
                });

                if (this.sortBy == 'date-special-sorting') {
                    let dateSortProcess = '';
                    let tmpAsc = true;
                    if (this.dpDateSort == 1) {
                        dateSortProcess = 'dp_sub_date';
                        tmpAsc = true;
                    }
                    if (this.dpDateSort == 2) {
                        dateSortProcess = 'dp_sub_date';
                        tmpAsc = false;
                    }
                    if (this.dpDateSort == 3) {
                        dateSortProcess = 'dp_app_date';
                        tmpAsc = true;
                    }
                    if (this.dpDateSort == 4) {
                        dateSortProcess = 'dp_app_date';
                        tmpAsc = false;
                    }
                    if (this.bpDateSort == 1) {
                        dateSortProcess = 'bp_sub_date';
                        tmpAsc = true;
                    }
                    if (this.bpDateSort == 2) {
                        dateSortProcess = 'bp_sub_date';
                        tmpAsc = false;
                    }
                    if (this.bpDateSort == 3) {
                        dateSortProcess = 'bp_app_date';
                        tmpAsc = true;
                    }
                    if (this.bpDateSort == 4) {
                        dateSortProcess = 'bp_app_date';
                        tmpAsc = false;
                    }
                    if (this.rzDateSort == 1) {
                        dateSortProcess = 'rz_sub_date';
                        tmpAsc = true;
                    }
                    if (this.rzDateSort == 2) {
                        dateSortProcess = 'rz_sub_date';
                        tmpAsc = false;
                    }
                    if (this.rzDateSort == 3) {
                        dateSortProcess = 'rz_app_date';
                        tmpAsc = true;
                    }
                    if (this.rzDateSort == 4) {
                        dateSortProcess = 'rz_app_date';
                        tmpAsc = false;
                    }
                    if (tmpAsc) {
                        ob = vm.types.sort((a,b) => 
                            {
                                if (a[dateSortProcess] == '') {
                                    return 1;
                                }
                                if (b[dateSortProcess] == '') {
                                    return -1;
                                }
                                if (Date.parse(a[dateSortProcess]) > Date.parse(b[dateSortProcess])) {
                                    return -1;
                                }
                                else {
                                    return 1;
                                }
                            }
                        );
                    }
                    else {
                        ob = vm.types.sort((a,b) => 
                            {
                                if (a[dateSortProcess] == '') {
                                    return -1;
                                }
                                if (b[dateSortProcess] == '') {
                                    return 1;
                                }
                                if (Date.parse(a[dateSortProcess]) > Date.parse(b[dateSortProcess])) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            }
                        );
                    }
                }

                let digitSorting = {
                    'sort-story' : 'storeys',
                    'sort-total-u' : 'units',
                    'sort-sold' : 'sold_unit_percent',
                    'sort-psf': 'psf'
                }
                Object.keys(digitSorting).forEach(function (k) {
                    if (k == vm.sortBy) {
                        if (vm.orderAsc) {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return 1;
                                    }
                                    else {
                                        return -1;
                                    }
                                }
                            );
                        }
                        else {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[digitSorting[k]] == '' || a[digitSorting[k]] == null) {
                                        if (b[digitSorting[k]] > 0) {
                                            return 1;
                                        }
                                        else {
                                            return -1;
                                        }
                                    }
                                    if (b[digitSorting[k]] == '' || b[digitSorting[k]] == null) {
                                        if (a[digitSorting[k]] > 0) {
                                            return -1;
                                        }
                                        else {
                                            return 1;
                                        }
                                    }
                                    if (parseInt(a[digitSorting[k]]) > parseInt(b[digitSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                    }
                });

                let dateSorting = {
                    'sort-sales-start-date' : 'sales_start_date',
                    'sort-construction-complete-date' : 'construction_complete_date',
                    'sort-sold-out-date' : 'sold_out_date',
                }
                Object.keys(dateSorting).forEach(function (k) {
                    if (k == vm.sortBy) {
                        if (vm.orderAsc) {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[dateSorting[k]] == '') {
                                        return 1;
                                    }
                                    if (b[dateSorting[k]] == '') {
                                        return -1;
                                    }
                                    if (Date.parse(a[dateSorting[k]]) > Date.parse(b[dateSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                        else {
                            ob = vm.types.sort((a,b) => 
                                {
                                    if (a[dateSorting[k]] == '') {
                                        return 1;
                                    }
                                    if (b[dateSorting[k]] == '') {
                                        return -1;
                                    }
                                    if (Date.parse(a[dateSorting[k]]) > Date.parse(b[dateSorting[k]])) {
                                        return -1;
                                    }
                                    else {
                                        return 1;
                                    }
                                }
                            );
                        }
                    }
                });

                return ob;
            }
        },
        methods:{
            devSearch(input) {
                const url = BACKEND_URL + `api/developers?search=${encodeURI(input)}`

                return new Promise((resolve) => {
                    if (input.length < 3) {
                    return resolve([])
                    }

                    fetch(url)
                        .then((response) => response.json())
                        .then((data) => {
                        resolve(data)
                    })
                })
            },
            onSubmit(result) {
                this.developerSearch = result.nid
            },
            getResultValue(result) {
                return result.title
            },
            LandReset() {

            },
            LandGo() {
                const vm = this;
                let q = {};
                if (this.parcelStatusLandSelected) {
                    q['status[]'] = this.parcelStatusLandSelected;
                }
                if (this.regTypeSelected) {
                    q['type[]'] = this.regTypeSelected;
                }
                if (this.LTSAPlanSearch) {
                    q['plansearch'] = this.LTSAPlanSearch;
                }
                if (this.LTSARegistrationSearch) {
                    q['regsearch'] = this.LTSARegistrationSearch;
                }
                if (this.ltsapid) {
                    q['pid'] = this.ltsapid;
                }
                if (this.landSalePriceMin) {
                    q['salepricemin'] = this.landSalePriceMin;
                }
                if (this.landSalePriceMax) {
                    q['salepricemax'] = this.landSalePriceMax;
                }
                if (this.landLotSizeMin) {
                    q['sizemin'] = this.landLotSizeMin;
                }
                if (this.landLotSizeMax) {
                    q['sizemax'] = this.landLotSizeMax;
                }
                if (this.registrationLandDate) {
                    q['regdate[]'] = new Array();
                }
                if (this.landCitiesSelected) {
                    q['city[]'] = this.landCitiesSelected;
                }
                this.registrationLandDate.forEach(function(value, i){
                    q['regdate[]'].push(vm.toTimestamp(value));
                });

                this.$router.push({ path: '/land-list', query: q});
                this.$router.go();
            },
            MLSReset() {

            },
            MLSGo() {
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                if (this.aptMLSIsActive) {
                    q['type[]'].push('2886');
                }
                if (this.townhomeMLSIsActive) {
                     q['type[]'].push('2870');
                }
                if (this.mixedUseAptMLSIsActive) {
                     q['type[]'].push('2884');
                }
                if (this.podiumMLSIsActive) {
                     q['type[]'].push('5910');
                }
                if (this.stackedTownhomeMLSIsActive) {
                     q['type[]'].push('3479');
                }
                if (this.commercialMLSIsActive) {
                     q['type[]'].push('2962');
                }
                if (this.industrialMLSIsActive) {
                     q['type[]'].push('3047');
                }
                if (this.rowhomeMLSIsActive) {
                     q['type[]'].push('6240');
                }
                if (this.statusMLSSelected) {
                    q['status[]'] = this.statusMLSSelected;
                }
                if (this.mlsCitiesSelected) {
                    q['city[]'] = this.mlsCitiesSelected;
                }
                if (this.gutMLSSelected) {
                    q['gut[]'] = this.gutMLSSelected;
                }
                if (this.mlsBedsMax) {
                    q['mlsbedsmax'] = this.mlsBedsMax;
                }
                if (this.mlsBedsMin) {
                    q['mlsbedsmin'] = this.mlsBedsMin;
                }
                if (this.mlsBathsMax) {
                    q['mlsbathsmax'] = this.mlsBathsMax;
                }
                if (this.mlsBathsMin) {
                    q['mlsbathsmin'] = this.mlsBathsMin;
                }
                if (this.mlsUnitMax) {
                    q['mlsunitmax'] = this.mlsUnitMax;
                }
                if (this.mlsUnitMin) {
                    q['mlsunitmin'] = this.mlsUnitMin;
                }
                if (this.listMLSDate) {
                    q['listmlsdate[]'] = new Array();
                }
                this.listMLSDate.forEach(function(value, i){
                    q['listmlsdate[]'].push(vm.toTimestamp(value));
                });
                if (this.soldMLSDate) {
                    q['soldmlsdate[]'] = new Array();
                }
                this.soldMLSDate.forEach(function(value, i){
                    q['soldmlsdate[]'].push(vm.toTimestamp(value));
                });
                if (this.mlsListPriceMin) {
                    q['mlslistpricemin'] = this.mlsListPriceMin;
                }
                if (this.mlsListPriceMax) {
                    q['mlslistpricemax'] = this.mlsListPriceMax;
                }
                if (this.mlsSoldPriceMin) {
                    q['mlssoldpricemin'] = this.mlsSoldPriceMin;
                }
                if (this.mlsSoldPriceMax) {
                    q['mlssoldpricemax'] = this.mlsSoldPriceMax;
                }
            
                this.$router.push({ path: '/mls-list', query: q});
                this.$router.go();
            },
            moreFilter() {
                $(".hidden-listing-filter").slideToggle(500);
                // $(this).find("span").toggleClass("mfilopact");
            },
            toggleDateSorting(sorting) {
                this.sortBy = 'date-special-sorting';
                this.rzDateSort = 0;
                this.bpDateSort = 0;
                this.dpDateSort = 0;
                switch (sorting) {
                    case 'rzSubNew':
                        this.rzDateSort = 1;
                        break;
                    case 'rzSubOld':
                        this.rzDateSort = 2;
                        break;
                    case 'rzAppNew':
                        this.rzDateSort = 3;
                        break;
                    case 'rzAppOld':
                        this.rzDateSort = 4;
                        break;
                    case 'bpSubNew':
                        this.bpDateSort = 1;
                        break;
                    case 'bpSubOld':
                        this.bpDateSort = 2;
                        break;
                    case 'bpAppNew':
                        this.bpDateSort = 3;
                        break;
                    case 'bpAppOld':
                        this.bpDateSort = 4;
                        break;
                    case 'dpSubNew':
                        this.dpDateSort = 1;
                        break;
                    case 'dpSubOld':
                        this.dpDateSort = 2;
                        break;
                    case 'dpAppNew':
                        this.dpDateSort = 3;
                        break;
                    case 'dpAppOld':
                        this.dpDateSort = 4;
                        break;
                    default:
                        break;
                }
            },
            dateSorting(sorting) {
                switch (sorting) {
                    case 'rzSubNew':
                        if (this.rzDateSort == 1) {
                            return 'status-selected';
                        }
                        break;
                    case 'rzSubOld':
                        if (this.rzDateSort == 2) {
                            return 'status-selected';
                        }
                        break;
                    case 'rzAppNew':
                        if (this.rzDateSort == 3) {
                            return 'status-selected';
                        }
                        break;
                    case 'rzAppOld':
                        if (this.rzDateSort == 4) {
                            return 'status-selected';
                        }
                        break;
                    case 'bpSubNew':
                        if (this.bpDateSort == 1) {
                            return 'status-selected';
                        }
                        break;
                    case 'bpSubOld':
                        if (this.bpDateSort == 2) {
                            return 'status-selected';
                        }
                        break;
                    case 'bpAppNew':
                        if (this.bpDateSort == 3) {
                            return 'status-selected';
                        }
                        break;
                    case 'bpAppOld':
                        if (this.rzDateSort == 4) {
                            return 'status-selected';
                        }
                        break;
                    case 'dpSubNew':
                        if (this.dpDateSort == 1) {
                            return 'status-selected';
                        }
                        break;
                    case 'dpSubOld':
                        if (this.dpDateSort == 2) {
                            return 'status-selected';
                        }
                        break;
                    case 'dpAppNew':
                        if (this.dpDateSort == 3) {
                            return 'status-selected';
                        }
                        break;
                    case 'dpAppOld':
                        if (this.dpDateSort == 4) {
                            return 'status-selected';
                        }
                        break;
                    default:
                        break;
                }
                return '';
            },
            toggleBpStatus(bpStatus) {
                this.bpFilter = bpStatus;
                this.rzFilter = '';
                this.dpFilter = '';
            },
            toggleDpStatus(dpStatus) {
                this.dpFilter = dpStatus;
                this.rzFilter = '';
                this.bpFilter = '';
            },
            toggleRzStatus(rzStatus) {
                this.rzFilter = rzStatus;
                this.dpFilter = '';
                this.bpFilter = '';
            },
            toggleConstruction(construction) {
                this.constructionFilter = construction;
            },
            toggleGroupOneStatus(status) {
                if (status == 'Denied') {
                    return 'Denied';
                }
                else {
                    return 'Submission';
                }
            },
            toggleGroupTwoStatus(status) {
                if (status == 'Issued') {
                    return 'Issued';
                }
                else if (status == 'Complete') {
                    return 'Completion';
                }
                else if (status == 'Approved') {
                    return 'Approval';
                }
                else {
                    return 'Approval';
                }
            },
            toggleMenu() {
                this.menuStatus = !this.menuStatus;
            },
            toggleMapBox() {
                this.mapActive = !this.mapActive;
            },
            closeMapBox() {
                this.mapActive = false;
            },
            refreshMapBox(box) {
                if (this.mapActive == true) {
                    this.mapActive = !this.mapActive;
                }
                else {
                    this.mapActive = !this.mapActive;
                    this.mapActive = !this.mapActive;
                }
            },
            classStatus(status) {
                switch (status) {
                    case 'Now Selling':
                        return 'now-selling-color';
                    case 'Now Leasing':
                        return 'now-leasing-color';
                    case 'Selling Soon':
                        return 'selling-soon-color';
                    case 'In Planning':
                        return 'in-planning-color';
                    case 'Sold Out':
                    case 'Sold Out 2':
                        return 'sold-out-color';
                    case 'Leasing Soon':
                        return 'leasing-soon-color';
                    case 'Leased Out':
                        return 'leased-out-color';
                }
            },
            reset() {

            },
            toggleBool(val) {
                this[val] = !this[val];
            },
            statusSwitch (status) {
                switch (status) {
                    case 'Denied':
                        return 'status-red';
                        break;
                    case 'Not Submitted':
                        return 'status-grey';
                        break;
                    case 'In Process':
                        return 'status-yellow';
                        break;
                    case 'Approved':
                        return 'status-purple';
                        break;
                    case 'Issued':
                        return 'status-blue';
                        break;
                    case 'Complete':
                        return 'status-green';
                        break;
                    default:
                        return 'status-transparent';
                        break;
                }
            },
            toTimestamp(strDate){
                var datum = Date.parse(strDate);
                return datum/1000;
            },
            date_sort(column) {
                if (this.dateSort == 'app') {
                    this.dateSort = 'sub';
                }
                else {
                    this.dateSort = 'app';
                }
                this.dateNameSort = column;
            },
            project_sort(column) {
                if (this.sortBy == column) {
                    this.orderAsc = !this.orderAsc;
                }
                this.sortBy = column;
                if (column == 'sort-dp-status') {
                    this.dateNameSort = 'dp';
                }
                if (column == 'sort-rz-status') {
                    this.dateNameSort = 'rz';
                }
                if (column == 'sort-bp-status') {
                    this.dateNameSort = 'bp';
                }
            },
            switchMap() {
                this.mapSwitch = !this.mapSwitch;
                this.$cookies.set("mapswitched","1",60 * 60 * 24 * 30*30);
            },
            orderedCollection: function (collection) {
                return _.orderBy(collection, 'p_status_tid', 'desc')
            },
            onReport() {
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                q['city[]'] = new Array();
                q['status[]'] = new Array();
                q['constructionstatus[]'] = new Array();
                q['unittype[]'] = new Array();
                if (this.listSearch) {
                    q['search'] = this.listSearch;
                }
                if (this.developerSearch) {
                    q['developer'] = this.developerSearch;
                }
                q['report[]'] = new Array();
                if (this.aptIsActive) {
                    q['type[]'].push('2886');
                }
                if (this.townhomeIsActive) {
                     q['type[]'].push('2870');
                }
                if (this.mixedUseAptIsActive) {
                     q['type[]'].push('2884');
                }
                if (this.podiumIsActive) {
                     q['type[]'].push('5910');
                }
                if (this.stackedTownhomeIsActive) {
                     q['type[]'].push('3479');
                }
                if (this.commercialIsActive) {
                     q['type[]'].push('2962');
                }
                if (this.industrialIsActive) {
                     q['type[]'].push('3047');
                }
                if (this.rowhomeIsActive) {
                     q['type[]'].push('6240');
                }
                $('#step1').next().find('ul.list .selected').each(function() {
                        q['type[]'].push($(this).attr('data-value'));
                });
                // $('#step2').next().find('ul.list .selected').each(function() {
                //         q['city[]'].push($(this).attr('data-value'));
                // });
                $('#step3').next().find('ul.list .selected').each(function() {
                        q['status[]'].push($(this).attr('data-value'));
                });
                $('#step4').next().find('ul.list .selected').each(function() {
                        q['constructionstatus[]'].push($(this).attr('data-value'));
                });
                $('#report').next().find('ul.list .selected').each(function() {
                        q['report[]'].push($(this).attr('data-value'));
                });
                // date group
                if (this.rzSubDate) {
                    q['rzSubDate[]'] = new Array();
                }

                if (this.role == 'admin') {
                    q['unittype[]'] = this.gutSelected;
                    q['city[]'] = this.citiesSelected;
                    if (this.reportSelected == 'projectTotal') {
                        [
                            {id: 'sales_start_date', label: 'Sales Start Date', isDisabled: true},
                            {id: 'total_units', label: 'Total Units', isDisabled: true},
                            {id: 'rlsd_units', label: 'Rlsds Units', isDisabled: true},
                            {id: 'sold_units', label: 'Sold Units', isDisabled: true},
                            {id: 'available', label: 'Available Units', isDisabled: true},
                            {id: 'total_avg_psf', label: 'Total Average $PSF', isDisabled: true},
                            {id: 'total_avg_size', label: 'Total Avg Size', isDisabled: true},
                            {id: 'total_avg_price', label: 'Total Avg Price', isDisabled: true},
                            {id: 'updated', label: 'Updated', isDisabled: true}
                        ].forEach(function(val, i){
                            q['report[]'].push(val.id);
                        });
                    }
                    else if (this.reportSelected == 'projectAvailability') {
                        [
                            {id: 'sales_start_date', label: 'Sales Start Date', isDisabled: true},
                            {id: 'total_units', label: 'Total Units', isDisabled: true},
                            {id: 'rlsd_units', label: 'Rlsds Units', isDisabled: true},
                            {id: 'sold_units', label: 'Sold Units', isDisabled: true},
                            {id: 'available', label: 'Available Units', isDisabled: true},
                            {id: 'current_avg_size', label: 'Current Avg Size', isDisabled: true},
                            {id: 'current_avg_price', label: 'Current Avg Price', isDisabled: true},
                            {id: 'current_avg_psf', label: 'Current Average $PSF', isDisabled: true}
                        ].forEach(function(val, i){
                            q['report[]'].push(val.id);
                        });
                    }
                    else if (this.reportSelected == 'planningReport') {
                        [
                            {id: 'rezoning_status', label: 'Rezoning Status', isDisabled: true},
                            {id: 'dp_status', label: 'DP status', isDisabled: true},
                            {id: 'bp_status', label: 'BP Status', isDisabled: true},
                            // {id: 'application_stage', label: 'Application Stage', isDisabled: true},
                            // {id: 'application_date', label: 'Application Date ', isDisabled: true}
                        ].forEach(function(val, i){
                            q['report[]'].push(val.id);
                        });
                    }
                }
                else {
                    q['unittype[]'] = [11153, 2952];
                    q['city[]'] = [2887];
                    var status_selected = 'now_selling';
                    $('#step3').next().find('ul.list .selected').each(function() {
                        status_selected = $(this).attr('data-value');
                    });
                    if (status_selected == 'now_selling') {
                        [
                            {id: 'sales_start_date', label: 'Sales Start Date', isDisabled: true},
                            {id: 'total_units', label: 'Total Units', isDisabled: true},
                            {id: 'rlsd_units', label: 'Rlsds Units', isDisabled: true},
                            {id: 'sold_units', label: 'Sold Units', isDisabled: true},
                            {id: 'available', label: 'Available Units', isDisabled: true},
                            {id: 'total_avg_psf', label: 'Total Average $PSF', isDisabled: true},
                            {id: 'total_avg_size', label: 'Total Avg Size', isDisabled: true},
                            {id: 'total_avg_price', label: 'Total Avg Price', isDisabled: true},
                            {id: 'updated', label: 'Updated', isDisabled: true}
                        ].forEach(function(val, i){
                            q['report[]'].push(val.id);
                        });
                    }
                    else if (status_selected == 'sold_out' || status_selected == 'sold_out_2') {
                        [
                            {id: 'sales_start_date', label: 'Sales Start Date', isDisabled: true},
                            {id: 'sold_out_date', label: 'Sold Out Date', isDisabled: true},
                            {id: 'total_units', label: 'Total Units', isDisabled: true},
                            {id: 'rlsd_units', label: 'Rlsds Units', isDisabled: true},
                            {id: 'sold_units', label: 'Sold Units', isDisabled: true},
                            {id: 'available', label: 'Available Units', isDisabled: true},
                            {id: 'total_avg_psf', label: 'Total Average $PSF', isDisabled: true},
                            {id: 'total_avg_size', label: 'Total Avg Size', isDisabled: true},
                            {id: 'total_avg_price', label: 'Total Avg Price', isDisabled: true},
                        ].forEach(function(val, i){
                            q['report[]'].push(val.id);
                        });
                    }
                    else {
                        [
                            {id: 'rezoning_status', label: 'Rezoning Status', isDisabled: true},
                            {id: 'dp_status', label: 'DP status', isDisabled: true},
                            {id: 'bp_status', label: 'BP Status', isDisabled: true},
                            // {id: 'application_stage', label: 'Application Stage', isDisabled: true},
                            // {id: 'application_date', label: 'Application Date ', isDisabled: true}
                        ].forEach(function(val, i){
                            q['report[]'].push(val.id);
                        });
                    }
                }


                this.rzSubDate.forEach(function(value, i){
                    q['rzSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.rzAppDate) {
                    q['rzAppDate[]'] = new Array();
                }
                this.rzAppDate.forEach(function(value, i){
                    q['rzAppDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpSubDate) {
                    q['dpSubDate[]'] = new Array();
                }
                this.dpSubDate.forEach(function(value, i){
                    q['dpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpSubDate) {
                    q['bpSubDate[]'] = new Array();
                }
                this.bpSubDate.forEach(function(value, i){
                    q['bpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpIssueDate) {
                    q['dpIssueDate[]'] = new Array();
                }
                this.dpIssueDate.forEach(function(value, i){
                    q['dpIssueDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpIssueDate) {
                    q['bpIssueDate[]'] = new Array();
                }
                this.bpIssueDate.forEach(function(value, i){
                    q['bpIssueDate[]'].push(vm.toTimestamp(value));
                });

                //  status group
                if (this.rzStatus) {
                    q['rzStatus[]'] = new Array();
                }
                this.rzStatus.forEach(function(value, i){
                    q['rzStatus[]'].push(value);
                });

                if (this.bpStatus) {
                    q['bpStatus[]'] = new Array();
                }
                this.bpStatus.forEach(function(value, i){
                    q['bpStatus[]'].push(value);
                });

                if (this.dpStatus) {
                    q['dpStatus[]'] = new Array();
                }
                this.dpStatus.forEach(function(value, i){
                    q['dpStatus[]'].push(value);
                });
                if (!vm.polyGon) {
                    localStorage.clear();
                }
                this.$router.push({ path: '/report', query: q});
                this.$router.go();
            },
            onGo() {
                const vm = this;
                let q = {};
                q['type[]'] = new Array();
                q['city[]'] = new Array();
                q['status[]'] = new Array();
                q['constructionstatus[]'] = new Array();
                q['unittype[]'] = new Array();
                if (this.listSearch) {
                    q['search'] = this.listSearch;
                }
                if (this.developerSearch) {
                    q['developer'] = this.developerSearch;
                }
                if (this.aptIsActive) {
                    q['type[]'].push('2886');
                }
                if (this.townhomeIsActive) {
                     q['type[]'].push('2870');
                }
                if (this.mixedUseAptIsActive) {
                     q['type[]'].push('2884');
                }
                if (this.podiumIsActive) {
                     q['type[]'].push('5910');
                }
                if (this.stackedTownhomeIsActive) {
                     q['type[]'].push('3479');
                }
                if (this.commercialIsActive) {
                     q['type[]'].push('2962');
                }
                if (this.industrialIsActive) {
                     q['type[]'].push('3047');
                }
                if (this.rowhomeIsActive) {
                     q['type[]'].push('6240');
                }
                $('#step1').next().find('ul.list .selected').each(function() {
                        q['type[]'].push($(this).attr('data-value'));
                });
                q['city[]'] = this.citiesSelected;
                // $('#step2').next().find('ul.list .selected').each(function() {
                //         q['city[]'].push($(this).attr('data-value'));
                // });
                $('#step3').next().find('ul.list .selected').each(function() {
                        q['status[]'].push($(this).attr('data-value'));
                });
                $('#step4').next().find('ul.list .selected').each(function() {
                        q['constructionstatus[]'].push($(this).attr('data-value'));
                });
                // $('#step5').next().find('ul.list .selected').each(function() {
                //         q['unittype[]'].push($(this).attr('data-value'));
                // });
                q['unittype[]'] = this.gutSelected;
                // date group
                if (this.rzSubDate) {
                    q['rzSubDate[]'] = new Array();
                }
                this.rzSubDate.forEach(function(value, i){
                    q['rzSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.rzAppDate) {
                    q['rzAppDate[]'] = new Array();
                }
                this.rzAppDate.forEach(function(value, i){
                    q['rzAppDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpSubDate) {
                    q['dpSubDate[]'] = new Array();
                }
                this.dpSubDate.forEach(function(value, i){
                    q['dpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpSubDate) {
                    q['bpSubDate[]'] = new Array();
                }
                this.bpSubDate.forEach(function(value, i){
                    q['bpSubDate[]'].push(vm.toTimestamp(value));
                });

                if (this.dpIssueDate) {
                    q['dpIssueDate[]'] = new Array();
                }
                this.dpIssueDate.forEach(function(value, i){
                    q['dpIssueDate[]'].push(vm.toTimestamp(value));
                });

                if (this.bpIssueDate) {
                    q['bpIssueDate[]'] = new Array();
                }
                this.bpIssueDate.forEach(function(value, i){
                    q['bpIssueDate[]'].push(vm.toTimestamp(value));
                });

                //  status group
                if (this.rzStatus) {
                    q['rzStatus[]'] = new Array();
                }
                this.rzStatus.forEach(function(value, i){
                    q['rzStatus[]'].push(value);
                });

                if (this.bpStatus) {
                    q['bpStatus[]'] = new Array();
                }
                this.bpStatus.forEach(function(value, i){
                    q['bpStatus[]'].push(value);
                });

                if (this.dpStatus) {
                    q['dpStatus[]'] = new Array();
                }
                this.dpStatus.forEach(function(value, i){
                    q['dpStatus[]'].push(value);
                });
                this.$router.push({ path: '/listing', query: q});
                this.$router.go();
            },
            getLink(nid, fid, sid) {
                return '/type?project='+nid+'&fid='+fid + '&sid='+sid;
            },
            getSellingSoonLink(nid) {
                return '/selling_soon?project_id=' + nid;
            },
            locationData: function(project) {
                var vm = this;
                let popuphtml = `
                    <div class="map-popup-wrap">
                        <div class="map-popup">
                            <div class="infoBox-close"><i class="fa fa-times"></i></div>
                            <div class="listing-content fl-wrap popup-slide-`+project.fid+`">
                            <div class="listing-title fl-wrap">
                                <div style="padding: 0 5px; display: inline-block;">
                                    <a href="`+project.ptc_info.link+`"><h4>`+project.ptc_info.name+`</h4></a>
                                    <h4>`+project.ptc_info.type+`</h4>
                                    <h4>`+project.ptc.storey+` Storey</h4>
                                    <h4>Lot `+project.ptc_info.lot+`</h4>
                                </div>
                            </div>`;
                            popuphtml += `</div>
                        </div>
                    </div>`;
                    return popuphtml;
            },
            mainMap: function() {
                const vm = this;
                var mouseLeave = true;
                var all_overlays = [];
                var selectedColor;
                var selectedShape;
                var colorButtons = {};
                var colors = ['#1E90FF', '#FF1493', '#32CD32', '#FF8C00', '#4B0082'];
                var locations = this.locations;
                var rzStatus = [];
                var dpStatus = [];
                var bpStatus = [];
                if (this.role == 'admin') {
                    var map = new google.maps.Map(document.getElementById('map-main'), {
                        scrollwheel: false,
                        center: new google.maps.LatLng(49.2827, -123.1207),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        zoomControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        panControl: false,
                        fullscreenControl: true,
                        navigationControl: false,
                        streetViewControl: false,
                        animation: google.maps.Animation.BOUNCE,
                        gestureHandling: 'greedy',
                        zoom: 10,
                        styles: [{
                            "featureType": "administrative",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#444444"
                            }]
                        }]
                    });
                }
                else {
                    var map = new google.maps.Map(document.getElementById('map-main'), {
                        scrollwheel: false,
                        center: new google.maps.LatLng(49.105271073890265, -122.7322570317265),
                        mapTypeId: google.maps.MapTypeId.ROADMAP,
                        zoomControl: false,
                        mapTypeControl: false,
                        scaleControl: false,
                        panControl: false,
                        fullscreenControl: true,
                        navigationControl: false,
                        streetViewControl: false,
                        animation: google.maps.Animation.BOUNCE,
                        gestureHandling: 'greedy',
                        zoom: 11,
                        styles: [{
                            "featureType": "administrative",
                            "elementType": "labels.text.fill",
                            "stylers": [{
                                "color": "#444444"
                            }]
                        }]
                    });
                }

                var oms = new OverlappingMarkerSpiderfier(map,{markersWontMove: true, markersWontHide: true, keepSpiderfied: true});
                var blueMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#6EBBF8" stroke="white" stroke-width="3"/></svg>';
                var greenMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#60B85F" stroke="white" stroke-width="3"/></svg>';
                var orangeMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#FF9357" stroke="white" stroke-width="3"/></svg>';
                var yellowMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#f5f242" stroke="white" stroke-width="3"/></svg>';
                var navyMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#0b4add" stroke="white" stroke-width="3"/></svg>';
                var redMarker = '<svg width="35" height="51" viewBox="0 0 35 51" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 0C7.8505 0 0 8.04326 0 17.9297C0 21.27 0.903098 24.5298 2.61226 27.3579L16.5039 50.2937C16.77 50.733 17.2388 51 17.743 51C17.7468 51 17.7506 51 17.7545 51C18.2631 50.9959 18.7329 50.7207 18.9941 50.2737L32.5316 27.1157C34.1465 24.3473 35 21.1709 35 17.9297C35 8.04326 27.1495 0 17.5 0Z" fill="#5E6274"/><path d="M26.2243 19.3671C26.2243 24.2778 22.3481 28.1962 17.6427 28.1962C12.9374 28.1962 9.06116 24.2778 9.06116 19.3671C9.06116 14.4564 12.9374 10.538 17.6427 10.538C22.3481 10.538 26.2243 14.4564 26.2243 19.3671Z" fill="#ff1953" stroke="white" stroke-width="3"/></svg>';
                oms.addListener('format', function(marker, status) {
                    marker.set('noHover', false);
                    if (status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED) {
                        var iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(blueMarker);
                        if (marker.icon_id == 2) {
                            iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(yellowMarker);
                        }
                        if (marker.icon_id == 3) {
                            iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(redMarker);
                        }
                        marker.setIcon({
                            anchor: new google.maps.Point(22, 16),
                            url: iconSvg,
                        });
                    }
                    // else if (status == OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE) {
                        
                    // }
                    else if (status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE) {
                        var iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(navyMarker);
                        if (marker.icon_id == 2) {
                            iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(yellowMarker);
                        }
                        if (marker.icon_id == 3) {
                            iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(redMarker);
                        }
                        marker.setIcon({
                            anchor: new google.maps.Point(22, 16),
                            url: iconSvg,
                        });
                        marker.set('noHover', true);
                    }
                    else {
                        var iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(blueMarker);
                        if (marker.icon_id == 2) {
                            iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(yellowMarker);
                        }
                        if (marker.icon_id == 3) {
                            iconSvg = 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(redMarker);
                        }
                        marker.setIcon({
                            anchor: new google.maps.Point(22, 16),
                            url: iconSvg,
                        });
                    }
                });

                function clearSelection() {
                    if (selectedShape) {
                        selectedShape.setEditable(false);
                        selectedShape = null;
                    }
                }

                function deleteSelectedShape() {
                    if (selectedShape) {
                        selectedShape.setMap(null);
                    }
                }

                $(document).on('mouseleave', '.summary-list', function(){
                    mouseLeave = true;
                });

                function selectColor(color) {
                    selectedColor = color;
                    for (var i = 0; i < colors.length; ++i) {
                        var currColor = colors[i];
                        colorButtons[currColor].style.border = currColor == color ? '2px solid #789' : '2px solid #fff';
                    }

                    // Retrieves the current options from the drawing manager and replaces the
                    // stroke or fill color as appropriate.
                    var polylineOptions = drawingManager.get('polylineOptions');
                    polylineOptions.strokeColor = color;
                    drawingManager.set('polylineOptions', polylineOptions);

                    var rectangleOptions = drawingManager.get('rectangleOptions');
                    rectangleOptions.fillColor = color;
                    drawingManager.set('rectangleOptions', rectangleOptions);

                    var circleOptions = drawingManager.get('circleOptions');
                    circleOptions.fillColor = color;
                    drawingManager.set('circleOptions', circleOptions);

                    var polygonOptions = drawingManager.get('polygonOptions');
                    polygonOptions.fillColor = color;
                    drawingManager.set('polygonOptions', polygonOptions);
                }

                function setSelection(shape) {
                    clearSelection();
                    selectedShape = shape;
                    shape.setEditable(true);
                    // selectColor(shape.get('fillColor') || shape.get('strokeColor'));
                }

                // draw feature
                var drawingManager = new google.maps.drawing.DrawingManager({
                    // drawingMode: google.maps.drawing.OverlayType.MARKER,
                    drawingControl: true,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.TOP_CENTER,
                        drawingModes: ['polygon']
                    },
                    // markerOptions: {icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'},
                    circleOptions: {
                        fillColor: '#ffff00',
                        fillOpacity: 1,
                        strokeWeight: 5,
                        clickable: false,
                        editable: true,
                        zIndex: 1
                    }
                });

                // $(document).on('change', '.rzCheck, .dpCheck, .bpCheck', function() {
                //     statusFilter();
                // });
                function statusFilter() {
                    rzStatus = [];
                    $('.rzGroup input').each(function() {
                        if ($(this).is(":checked")) {
                            rzStatus.push($(this).attr('tid'));
                        }
                    });
                    dpStatus = [];
                    $('.dpGroup input').each(function() {
                        if ($(this).is(":checked")) {
                            dpStatus.push($(this).attr('tid'));
                        }
                    });
                    bpStatus = [];
                    $('.bpGroup input').each(function() {
                        if ($(this).is(":checked")) {
                            bpStatus.push($(this).attr('tid'));
                        }
                    });
                    for (i = 0; i < allMarkers.length; i++) {
                        allMarkers[i].setVisible(true);
                        if (rzStatus.length > 0) {
                            if ($.inArray(allMarkers[i].rz_status, rzStatus) == -1) {
                                allMarkers[i].setVisible(false);
                            }
                        }
                        if (dpStatus.length > 0) {
                            if ($.inArray(allMarkers[i].dp_status, dpStatus) == -1) {
                                allMarkers[i].setVisible(false);
                            }
                        }
                        if (bpStatus.length > 0) {
                            if ($.inArray(allMarkers[i].bp_status, bpStatus) == -1) {
                                allMarkers[i].setVisible(false);
                            }
                        }
                    }
                    markerCluster.setIgnoreHidden(true);
                    markerCluster.repaint();
                }

                google.maps.event.addListener(drawingManager, 'drawingmode_changed', clearSelection);
                google.maps.event.addListener(map, 'click', clearSelection);

                drawingManager.setMap(map);

                function clearMarkers() {
                    setMapOnAll(null);
                }

                google.maps.event.addListener(drawingManager, 'overlaycomplete', function (e) {
                    deleteAllShape();
                    
                    all_overlays.push(e);
                    if (e.type != google.maps.drawing.OverlayType.MARKER) {
                        // Switch back to non-drawing mode after drawing a shape.
                        drawingManager.setDrawingMode(null);
                        // Add an event listener that selects the newly-drawn shape when the user
                        // mouses down on it.
                        var newShape = e.overlay;
                        newShape.type = e.type;
                        google.maps.event.addListener(newShape, 'click', function() {
                            setSelection(newShape);
                        });

                        // console.log(allMarkers);
                        // render markers based on polygon
                        vm.polyGon = true;
                        let uids = [];
                        for (i = 0; i < allMarkers.length; i++) {
                            if (google.maps.geometry.poly.containsLocation(allMarkers[i].position, e.overlay) == true) {
                                allMarkers[i].setVisible(true);
                                _.each(allMarkers[i]['uids'], (utc) => {
                                    uids.push(utc.uid)
                                });
                            }
                            else {
                                allMarkers[i].setVisible(false);
                            }
                        }
                        localStorage.setItem('uids', JSON.stringify(uids));
                        markerCluster.setIgnoreHidden(true);
                        markerCluster.repaint();
                        setSelection(newShape);
                    }
                });

                function deleteAllShape() {
                    for (var i = 0; i < all_overlays.length; i++) {
                        all_overlays[i].overlay.setMap(null);
                    }
                    all_overlays = [];
                }

                // clean
                $('.poly-clean').click(function(){
                    deleteAllShape();
                });

                var boxText = document.createElement("div");
                boxText.className = 'map-box'
                var currentInfobox;
                var boxOptions = {
                    content: boxText,
                    disableAutoPan: true,
                    alignBottom: true,
                    maxWidth: 0,
                    pixelOffset: new google.maps.Size(-145, -45),
                    zIndex: null,
                    boxStyle: {
                        width: "260px"
                    },
                    closeBoxMargin: "0",
                    closeBoxURL: "",
                    infoBoxClearance: new google.maps.Size(1, 1),
                    isHidden: false,
                    pane: "floatPane",
                    enableEventPropagation: false,
                    contextmenu:true,
                };
                var markerCluster, marker, i;
                var allMarkers = [];
                var clusterStyles = [{
                    textColor: 'white',
                    url: '',
                    height: 50,
                    width: 50
                }];
        
                for (i = 0; i < locations.length; i++) {
                    var icon = navyMarker;
                    if (locations[i][1]['icon'] == 2) {
                        icon = orangeMarker;
                    }
                    if (locations[i][1]['icon'] == 3) {
                        icon = redMarker;
                    }
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[i][1]['geo']['lat'], locations[i][1]['geo']['lng']),
                        icon: icon,
                        icon_id: locations[i][1]['icon'],
                        id: i,
                        fid: locations[i][1]['fid'],
                        boxContent: locations[i][0],
                        // t_status: locations[i][16],
                        noHover: false,
                        uids: locations[i][1]['utc']
                    });
                    allMarkers.push(marker);
                    oms.addMarker(marker);
                    var ib = new InfoBox();
                    google.maps.event.addListener(ib, "domready", function () {
                        cardRaining()
                    });
                    // if (this.initBeforeSearch) {
                    google.maps.event.addListener(marker, 'click', (function (marker, i) {
                        return function () {
                            if (!marker.noHover) {
                                ib.setOptions(boxOptions);
                                boxText.innerHTML = marker.boxContent;
                                currentInfobox = marker.id;
                                google.maps.event.addListener(ib, 'domready', function () {
                                    $('.infoBox-close').click(function (e) {
                                        e.preventDefault();
                                        ib.close();
                                    });
                                    // if (!$('.popup-slide-'+marker.fid).hasClass('slick-initialized')) {
                                    //     $('.popup-slide-'+marker.fid).slick({
                                    //         infinite: false,
                                    //         slidesToShow: 1,
                                    //         slidesToScroll: 1,
                                    //         dots: false,
                                    //         arrows: true,
                                    //         draggable: false,
                                    //     });
                                    // }
                                });
                                ib.close();
                                ib.open(map, marker);
                                google.maps.event.addListener(map, 'click', function () {
                                    ib.close();
                                    vm.closeMapBox();
                                });
                            }
                        }
                    })(marker, i));
                    // }
                    google.maps.event.addListener(marker, 'click', (function (marker, i) {
                        return function () {
                            var latLng = new google.maps.LatLng(locations[i][1]['geo']['lat'], locations[i][1]['geo']['lng']);
                            map.panTo(latLng);
                            map.panBy(0, -180);
                            vm.mapBox['name'] = locations[i][1]['utc'][0]['name'];
                            vm.mapBox['address'] = locations[i][1]['utc'][0]['address'];
                            vm.mapBox['site'] = locations[i][1]['utc'][0]['web_link'];
                            vm.mapBox['storeys'] = locations[i][8];
                            vm.mapBox['construction_status'] = locations[i][9];
                            vm.mapBox['sold'] = locations[i][10];
                            vm.mapBox['type'] = locations[i][1]['utc'][0]['type'];
                            vm.mapBox['psf'] = locations[i][12];
                            vm.mapBox['floor_plan_ref'] = locations[i][13];
                            vm.mapBox['units'] = locations[i][15];
                            vm.mapBox['status'] = locations[i][1]['utc'][0]['status'];
                            vm.mapBox['link'] = locations[i][1]['utc'][0]['ref_link'];
                            vm.mapBox['developer'] = locations[i][1]['utc'][0]['developer'];
                            // vm.refreshMapBox(vm.mapBox);
                        }
                    })(marker, i));
                }
                var options = {
                    imagePath: '/images/',
                    styles: clusterStyles,
                    minimumClusterSize: 2
                };
                markerCluster = new MarkerClusterer(map, allMarkers, options);
                markerCluster.setMaxZoom(15);

                google.maps.event.addDomListener(window, "resize", function () {
                    var center = map.getCenter();
                    google.maps.event.trigger(map, "resize");
                    map.setCenter(center);
                });

                $('.nextmap-nav').click(function (e) {
                    e.preventDefault();
                    map.setZoom(15);
                    var index = currentInfobox;
                    if (index + 1 < allMarkers.length) {
                        google.maps.event.trigger(allMarkers[index + 1], 'click');
                    } else {
                        google.maps.event.trigger(allMarkers[0], 'click');
                    }
                });
                $('.prevmap-nav').click(function (e) {
                    e.preventDefault();
                    map.setZoom(15);
                    if (typeof (currentInfobox) == "undefined") {
                        google.maps.event.trigger(allMarkers[allMarkers.length - 1], 'click');
                    } else {
                        var index = currentInfobox;
                        if (index - 1 < 0) {
                            google.maps.event.trigger(allMarkers[allMarkers.length - 1], 'click');
                        } else {
                            google.maps.event.trigger(allMarkers[index - 1], 'click');
                        }
                    }
                });
                $('.map-item').click(function (e) {
                    e.preventDefault();
                    map.setZoom(15);
                    var index = currentInfobox;
                    var marker_index = parseInt($(this).attr('href').split('#')[1], 10);
                    google.maps.event.trigger(allMarkers[marker_index], "click");
                    if ($(this).hasClass("scroll-top-map")){
                      $('html, body').animate({
                        scrollTop: $(".map-container").offset().top+ "-80px"
                      }, 500)
                    }
                    else if ($(window).width()<1064){
                      $('html, body').animate({
                        scrollTop: $(".map-container").offset().top+ "-80px"
                      }, 500)
                    }
                });
              // Scroll enabling button
              var scrollEnabling = $('.scrollContorl');

              $(scrollEnabling).click(function(e){
                  e.preventDefault();
                  $(this).toggleClass("enabledsroll");

                  if ( $(this).is(".enabledsroll") ) {
                     map.setOptions({'scrollwheel': true});
                  } else {
                     map.setOptions({'scrollwheel': false});
                  }
              });       
                var zoomControlDiv = document.createElement('div');
                var zoomControl = new ZoomControl(zoomControlDiv, map);

                function ZoomControl(controlDiv, map) {
                    zoomControlDiv.index = 1;
                    map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(zoomControlDiv);
                    controlDiv.style.padding = '5px';
                    var controlWrapper = document.createElement('div');
                    controlDiv.appendChild(controlWrapper);
                    var zoomInButton = document.createElement('div');
                    zoomInButton.className = "mapzoom-in";
                    controlWrapper.appendChild(zoomInButton);
                    var zoomOutButton = document.createElement('div');
                    zoomOutButton.className = "mapzoom-out";
                    controlWrapper.appendChild(zoomOutButton);
                    google.maps.event.addDomListener(zoomInButton, 'click', function () {
                        map.setZoom(map.getZoom() + 1);
                    });
                    google.maps.event.addDomListener(zoomOutButton, 'click', function () {
                        map.setZoom(map.getZoom() - 1);
                    });
                }

            }
        },
    }
</script>
<style>
.marker-sample {
    position: fixed;
    bottom: 0;
    z-index: 99999;
    background: #fff;
    padding: 0 15px 20px 15px;
    text-align: left;
}
@media (max-width: 767px) {
    .map-col, #map-main {
        height: 500px !important;
    }
    .logo-holder img {
        width: 100px;
        height: auto;
        margin-top: -12px;
    }
    .listsearch-input-item .nice-select .list li:hover {
        background: none;
        color: #666;
    }
    .listsearch-input-item .nice-select .list li.selected {
        color: #fff;
    }
}
</style>